import React from 'react';
import { useTheme } from '@material-ui/styles';
import PropTypes from 'prop-types';

export const HomeIcon = (props) => {
    const theme = useTheme();
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.3861 1.21065C11.7472 0.929784 12.2528 0.929784 12.6139 1.21065L21.6139 8.21065C21.8575 8.4001 22 8.69141 22 9V20C22 20.7957 21.6839 21.5587 21.1213 22.1213C20.5587 22.6839 19.7957 23 19 23H5C4.20435 23 3.44129 22.6839 2.87868 22.1213C2.31607 21.5587 2 20.7957 2 20V9C2 8.69141 2.14247 8.4001 2.38606 8.21065L11.3861 1.21065ZM4 9.48908V20C4 20.2652 4.10536 20.5196 4.29289 20.7071C4.48043 20.8946 4.73478 21 5 21H19C19.2652 21 19.5196 20.8946 19.7071 20.7071C19.8946 20.5196 20 20.2652 20 20V9.48908L12 3.26686L4 9.48908Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 12C8 11.4477 8.44772 11 9 11H15C15.5523 11 16 11.4477 16 12V22C16 22.5523 15.5523 23 15 23C14.4477 23 14 22.5523 14 22V13H10V22C10 22.5523 9.55228 23 9 23C8.44772 23 8 22.5523 8 22V12Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

HomeIcon.propTypes = {
    fill: PropTypes.string,
};

export const MessageIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.54549 15C5.00452 13.929 4.72418 12.7453 4.72731 11.5454C4.72787 10.1107 5.12787 8.70441 5.88251 7.48414C6.63715 6.26387 7.71662 5.2778 9.00002 4.63638C10.071 4.09541 11.2547 3.81507 12.4546 3.8182H12.9091C14.804 3.92274 16.5937 4.72253 17.9356 6.06443C19.2775 7.40633 20.0773 9.19605 20.1818 11.0909V11.5454C20.1849 12.7453 19.9046 13.929 19.3636 15C18.7222 16.2834 17.7361 17.3629 16.5159 18.1175C15.2956 18.8721 13.8893 19.2721 12.4546 19.2727C11.2547 19.2758 10.071 18.9955 9.00002 18.4545L3.81822 20.1818L5.54549 15ZM8.9007 20.4041L4.39318 21.9067C3.73985 22.1244 3.01955 21.9544 2.53258 21.4674C2.04561 20.9805 1.87557 20.2602 2.09335 19.6068L3.59586 15.0993C3.14035 13.9715 2.90621 12.7639 2.90914 11.5427C2.9102 9.77106 3.4043 8.03465 4.33614 6.52784C5.26767 5.02154 6.59988 3.80413 8.18373 3.01174C9.50871 2.34318 10.9727 1.99655 12.4568 2.00003H12.9091C12.9425 2.00003 12.9759 2.00095 13.0093 2.00279C15.351 2.13198 17.5628 3.1204 19.2212 4.77878C20.8796 6.43717 21.868 8.64899 21.9972 10.9907C21.9991 11.0241 22 11.0575 22 11.0909V11.5435C22.0034 13.0275 21.6568 14.4914 20.9882 15.8163C20.1958 17.4002 18.9784 18.7323 17.4722 19.6639C15.9653 20.5957 14.2289 21.0898 12.4573 21.0909C11.2361 21.0938 10.0284 20.8596 8.9007 20.4041Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

MessageIcon.propTypes = {
    fill: PropTypes.string,
};

export const UserIcon = (props) => {
    const theme = useTheme();
    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.46447 15.4645C5.40215 14.5268 6.67392 14 8 14H16C17.3261 14 18.5979 14.5268 19.5355 15.4645C20.4732 16.4021 21 17.6739 21 19V21C21 21.5523 20.5523 22 20 22C19.4477 22 19 21.5523 19 21V19C19 18.2044 18.6839 17.4413 18.1213 16.8787C17.5587 16.3161 16.7956 16 16 16H8C7.20435 16 6.44129 16.3161 5.87868 16.8787C5.31607 17.4413 5 18.2044 5 19V21C5 21.5523 4.55228 22 4 22C3.44772 22 3 21.5523 3 21V19C3 17.6739 3.52678 16.4021 4.46447 15.4645Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4ZM7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

UserIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const CalendarIcon = (props) => {
    const theme = useTheme();
    return (
        <svg
            width={props.width ? props.width : '17'}
            height={props.height ? props.height : '16'}
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.04102 0.666748C6.40921 0.666748 6.70768 0.965225 6.70768 1.33341V2.00008H10.7077V1.33341C10.7077 0.965225 11.0062 0.666748 11.3743 0.666748C11.7425 0.666748 12.041 0.965225 12.041 1.33341V2.00008H13.3743C14.4789 2.00008 15.3743 2.89551 15.3743 4.00008V6.66675V13.3334C15.3743 14.438 14.4789 15.3334 13.3743 15.3334H4.04102C2.93645 15.3334 2.04102 14.438 2.04102 13.3334V6.66675V4.00008C2.04102 2.89551 2.93645 2.00008 4.04102 2.00008H5.37435V1.33341C5.37435 0.965225 5.67283 0.666748 6.04102 0.666748ZM5.37435 3.33341H4.04102C3.67283 3.33341 3.37435 3.63189 3.37435 4.00008V6.00008H14.041V4.00008C14.041 3.63189 13.7425 3.33341 13.3743 3.33341H12.041V4.00008C12.041 4.36827 11.7425 4.66675 11.3743 4.66675C11.0062 4.66675 10.7077 4.36827 10.7077 4.00008V3.33341H6.70768V4.00008C6.70768 4.36827 6.40921 4.66675 6.04102 4.66675C5.67283 4.66675 5.37435 4.36827 5.37435 4.00008V3.33341ZM14.041 13.3334V7.33342H3.37435V13.3334C3.37435 13.7016 3.67283 14.0001 4.04102 14.0001H13.3743C13.7425 14.0001 14.041 13.7016 14.041 13.3334Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

CalendarIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const CalendarIcon2 = (props) => {
    const theme = useTheme();

    return (
        <svg
            width={props.width ? props.width : '20'}
            height={props.height ? props.height : '20'}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.66675 1.66663V4.16663"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.3333 1.66663V4.16663"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.91675 7.57495H17.0834"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.5 7.08329V14.1666C17.5 16.6666 16.25 18.3333 13.3333 18.3333H6.66667C3.75 18.3333 2.5 16.6666 2.5 14.1666V7.08329C2.5 4.58329 3.75 2.91663 6.66667 2.91663H13.3333C16.25 2.91663 17.5 4.58329 17.5 7.08329Z"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.0788 11.4167H13.0863"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.0788 13.9167H13.0863"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.99632 11.4167H10.0038"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.99632 13.9167H10.0038"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.91185 11.4167H6.91933"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.91185 13.9167H6.91933"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

CalendarIcon2.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const FileIcon = (props) => {
    const theme = useTheme();
    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.87868 1.87868C4.44129 1.31607 5.20435 1 6 1H14C14.2652 1 14.5196 1.10536 14.7071 1.29289L20.7071 7.29289C20.8946 7.48043 21 7.73478 21 8V20C21 20.7957 20.6839 21.5587 20.1213 22.1213C19.5587 22.6839 18.7957 23 18 23H6C5.20435 23 4.44129 22.6839 3.87868 22.1213C3.31607 21.5587 3 20.7957 3 20V4C3 3.20435 3.31607 2.44129 3.87868 1.87868ZM6 3C5.73478 3 5.48043 3.10536 5.29289 3.29289C5.10536 3.48043 5 3.73478 5 4V20C5 20.2652 5.10536 20.5196 5.29289 20.7071C5.48043 20.8946 5.73478 21 6 21H18C18.2652 21 18.5196 20.8946 18.7071 20.7071C18.8946 20.5196 19 20.2652 19 20V8.41421L13.5858 3H6Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14 1C14.5523 1 15 1.44772 15 2V7H20C20.5523 7 21 7.44772 21 8C21 8.55228 20.5523 9 20 9H14C13.4477 9 13 8.55228 13 8V2C13 1.44772 13.4477 1 14 1Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 8C7.44772 8 7 8.44772 7 9C7 9.55228 7.44772 10 8 10H10C10.5523 10 11 9.55228 11 9C11 8.44772 10.5523 8 10 8H8ZM7 13C7 12.4477 7.44772 12 8 12H16C16.5523 12 17 12.4477 17 13C17 13.5523 16.5523 14 16 14H8C7.44772 14 7 13.5523 7 13ZM7 17C7 16.4477 7.44772 16 8 16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H8C7.44772 18 7 17.5523 7 17Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

FileIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const DownloadIcon = (props) => {
    const theme = useTheme();
    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 14C3.55228 14 4 14.4477 4 15V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V15C20 14.4477 20.4477 14 21 14C21.5523 14 22 14.4477 22 15V19C22 19.7957 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7957 22 19 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7956 2 19V15C2 14.4477 2.44772 14 3 14Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L12 13.5858L16.2929 9.29289C16.6834 8.90237 17.3166 8.90237 17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2C12.5523 2 13 2.44772 13 3V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V3C11 2.44772 11.4477 2 12 2Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

DownloadIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const DownloadIcon2 = (props) => {
    const theme = useTheme();

    return (
        <svg
            width={props.width ? props.width : '18'}
            height={props.height ? props.height : '18'}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.3301 6.67499C15.0301 6.90749 16.1326 8.29499 16.1326 11.3325V11.43C16.1326 14.7825 14.7901 16.125 11.4376 16.125H6.55511C3.20261 16.125 1.86011 14.7825 1.86011 11.43V11.3325C1.86011 8.31749 2.94761 6.92999 5.60261 6.68249"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9 3V11.25"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.5125 9.48749L9.00005 12L6.48755 9.48749"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

DownloadIcon2.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const EditIcon = (props) => {
    const theme = useTheme();
    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 20C11 19.4477 11.4477 19 12 19H21C21.5523 19 22 19.4477 22 20C22 20.5523 21.5523 21 21 21H12C11.4477 21 11 20.5523 11 20Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18 3.87866C17.7026 3.87866 17.4174 3.9968 17.2071 4.20709L4.90299 16.5112L4.37439 18.6256L6.48877 18.097L18.7929 5.79288C18.897 5.68875 18.9796 5.56514 19.036 5.42909C19.0923 5.29305 19.1213 5.14724 19.1213 4.99998C19.1213 4.85273 19.0923 4.70692 19.036 4.57087C18.9796 4.43483 18.897 4.31121 18.7929 4.20709C18.6888 4.10296 18.5652 4.02037 18.4291 3.96402C18.2931 3.90767 18.1473 3.87866 18 3.87866ZM15.7929 2.79288C16.3783 2.20751 17.1722 1.87866 18 1.87866C18.4099 1.87866 18.8158 1.9594 19.1945 2.11626C19.5732 2.27312 19.9173 2.50303 20.2071 2.79288C20.497 3.08272 20.7269 3.42681 20.8837 3.8055C21.0406 4.1842 21.1213 4.59008 21.1213 4.99998C21.1213 5.40988 21.0406 5.81576 20.8837 6.19446C20.7269 6.57316 20.497 6.91725 20.2071 7.20709L7.70713 19.7071C7.57897 19.8352 7.41839 19.9262 7.24256 19.9701L3.24256 20.9701C2.90178 21.0553 2.54129 20.9555 2.29291 20.7071C2.04453 20.4587 1.94468 20.0982 2.02988 19.7574L3.02988 15.7574C3.07384 15.5816 3.16476 15.421 3.29291 15.2929L15.7929 2.79288Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

EditIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const TimeIcon = (props) => {
    const theme = useTheme();
    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 5C12.5523 5 13 5.44772 13 6V11.382L16.4472 13.1056C16.9412 13.3526 17.1414 13.9532 16.8944 14.4472C16.6474 14.9412 16.0468 15.1414 15.5528 14.8944L11.5528 12.8944C11.214 12.725 11 12.3788 11 12V6C11 5.44772 11.4477 5 12 5Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

TimeIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const MicIcon = (props) => {
    const theme = useTheme();
    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.17157 1.17157C9.92172 0.421427 10.9391 0 12 0C13.0609 0 14.0783 0.421427 14.8284 1.17157C15.5786 1.92172 16 2.93913 16 4V12C16 13.0609 15.5786 14.0783 14.8284 14.8284C14.0783 15.5786 13.0609 16 12 16C10.9391 16 9.92172 15.5786 9.17157 14.8284C8.42143 14.0783 8 13.0609 8 12V4C8 2.93913 8.42143 1.92172 9.17157 1.17157ZM12 2C11.4696 2 10.9609 2.21071 10.5858 2.58579C10.2107 2.96086 10 3.46957 10 4V12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12V4C14 3.46957 13.7893 2.96086 13.4142 2.58579C13.0391 2.21071 12.5304 2 12 2Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 9C5.55228 9 6 9.44772 6 10V12C6 13.5913 6.63214 15.1174 7.75736 16.2426C8.88258 17.3679 10.4087 18 12 18C13.5913 18 15.1174 17.3679 16.2426 16.2426C17.3679 15.1174 18 13.5913 18 12V10C18 9.44772 18.4477 9 19 9C19.5523 9 20 9.44772 20 10V12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20C9.87827 20 7.84344 19.1571 6.34315 17.6569C4.84285 16.1566 4 14.1217 4 12V10C4 9.44772 4.44772 9 5 9Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 18C12.5523 18 13 18.4477 13 19V23C13 23.5523 12.5523 24 12 24C11.4477 24 11 23.5523 11 23V19C11 18.4477 11.4477 18 12 18Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 23C7 22.4477 7.44772 22 8 22H16C16.5523 22 17 22.4477 17 23C17 23.5523 16.5523 24 16 24H8C7.44772 24 7 23.5523 7 23Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

MicIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const MicOffIcon = (props) => {
    const theme = useTheme();
    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L23.7071 22.2929C24.0976 22.6834 24.0976 23.3166 23.7071 23.7071C23.3166 24.0976 22.6834 24.0976 22.2929 23.7071L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                    fill={props.fill ? theme.palette.common[props.fill] : 'white'}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 8C9.55228 8 10 8.44772 10 9V11.9995C10.0004 12.3947 10.1179 12.7809 10.3376 13.1093C10.5574 13.4379 10.8696 13.694 11.2349 13.8452C11.6001 13.9964 12.002 14.0361 12.3897 13.959C12.7774 13.882 13.1336 13.6918 13.4133 13.4125C13.8041 13.0222 14.4373 13.0226 14.8275 13.4133C15.2178 13.8041 15.2174 14.4373 14.8267 14.8275C14.2673 15.3862 13.5549 15.7666 12.7794 15.9207C12.0039 16.0747 11.2002 15.9955 10.4697 15.6931C9.73927 15.3906 9.11481 14.8785 8.67524 14.2213C8.23567 13.5642 8.0007 12.7915 8 12.0009L8 9C8 8.44772 8.44772 8 9 8Z"
                    fill={props.fill ? theme.palette.common[props.fill] : 'white'}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.1201 7.99731C14.5678 7.99731 14.1201 7.5496 14.1201 6.99731L14.1201 3.99783C14.1197 3.60265 14.0022 3.21645 13.7825 2.88797C13.5627 2.5594 13.2505 2.30333 12.8852 2.1521C12.52 2.00086 12.1182 1.96126 11.7304 2.03829C11.3427 2.11531 10.9865 2.30551 10.7068 2.58486C10.316 2.97514 9.68285 2.97475 9.29257 2.58398C8.90229 2.19321 8.90268 1.56005 9.29345 1.16977C9.85285 0.611067 10.5653 0.230669 11.3407 0.0766192C12.1162 -0.0774311 12.9199 0.00177689 13.6504 0.304238C14.3808 0.606698 15.0053 1.11884 15.4449 1.776C15.8844 2.43315 16.1194 3.20582 16.1201 3.99644L16.1201 6.99731C16.1201 7.5496 15.6724 7.99731 15.1201 7.99731Z"
                    fill={props.fill ? theme.palette.common[props.fill] : 'white'}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.00019 9C5.55247 9 6.00019 9.44772 6.00019 10V12.0073C5.99144 13.2029 6.34009 14.3739 7.00145 15.37C7.66281 16.3661 8.6067 17.1419 9.71201 17.5978C10.8173 18.0538 12.0337 18.1691 13.205 17.929C14.3763 17.6888 15.4491 17.1042 16.2859 16.2502C16.6724 15.8557 17.3055 15.8492 17.7 16.2357C18.0945 16.6222 18.101 17.2553 17.7145 17.6498C16.5988 18.7886 15.1684 19.5681 13.6066 19.8882C12.0449 20.2084 10.4231 20.0546 8.94935 19.4467C7.4756 18.8388 6.21708 17.8044 5.33527 16.4763C4.45415 15.1492 3.98929 13.5893 4.00019 11.9965V10C4.00019 9.44772 4.4479 9 5.00019 9ZM19.0002 9C19.5525 9 20.0002 9.44772 20.0002 10V12C19.9998 12.4714 19.9577 12.9426 19.8745 13.4066C19.7769 13.9502 19.2572 14.3118 18.7136 14.2143C18.17 14.1168 17.8084 13.597 17.9059 13.0534C17.9683 12.7054 17.9999 12.3526 18.0002 11.9991V10C18.0002 9.44772 18.4479 9 19.0002 9Z"
                    fill={props.fill ? theme.palette.common[props.fill] : 'white'}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 18C12.5523 18 13 18.4477 13 19V23C13 23.5523 12.5523 24 12 24C11.4477 24 11 23.5523 11 23V19C11 18.4477 11.4477 18 12 18Z"
                    fill={props.fill ? theme.palette.common[props.fill] : 'white'}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7 23C7 22.4477 7.44772 22 8 22H16C16.5523 22 17 22.4477 17 23C17 23.5523 16.5523 24 16 24H8C7.44772 24 7 23.5523 7 23Z"
                    fill={props.fill ? theme.palette.common[props.fill] : 'white'}
                />
            </g>
            <defs>
                <clipPath id="clip0">
                    <rect
                        width="24"
                        height="24"
                        fill={props.fill ? theme.palette.common[props.fill] : 'white'}
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

MicOffIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const PhoneEndIcon = (props) => {
    const theme = useTheme();
    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 26 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21.6061 15.1963L21.6047 15.1977C21.383 15.4231 21.0864 15.5606 20.7703 15.5843C20.4545 15.608 20.1408 15.5165 19.8878 15.327C19.2976 14.8759 18.6581 14.4927 17.9815 14.1849L17.9811 14.1847C17.7537 14.0819 17.5607 13.9163 17.425 13.7077C17.2894 13.4992 17.2166 13.2565 17.215 13.0082V11.6609C17.215 11.5709 17.1548 11.4919 17.0679 11.4681C15.9986 11.1749 14.4992 11.0312 13.0107 11.0312C11.5221 11.0312 10.0227 11.1749 8.95339 11.4681C8.8665 11.4919 8.80626 11.5709 8.80626 11.6609V13.008C8.80477 13.2564 8.73194 13.4992 8.5963 13.7077C8.46056 13.9163 8.26761 14.0819 8.04022 14.1847L8.03978 14.1849C7.36319 14.4928 6.72367 14.8759 6.13344 15.327C5.87769 15.5186 5.56015 15.6101 5.2411 15.5838C4.92176 15.5575 4.62338 15.4151 4.40267 15.1839L4.40271 15.1838L4.3992 15.1803L2.80225 13.5886L2.80168 13.588C2.67263 13.4604 2.57178 13.3074 2.50554 13.1388C2.43931 12.9702 2.40914 12.7897 2.41696 12.6088C2.42477 12.428 2.47039 12.2507 2.55093 12.0884C2.63121 11.9266 2.74443 11.7832 2.8834 11.6673C4.67471 10.2322 6.77874 9.23569 9.02655 8.75795L9.02655 8.75796L9.02835 8.75756C10.0602 8.5283 11.5204 8.4118 12.9894 8.4118C14.4583 8.4118 15.9185 8.5283 16.9504 8.75756L16.9504 8.75757L16.9521 8.75793C19.2092 9.23878 21.321 10.2427 23.1164 11.6883C23.255 11.8039 23.3681 11.9468 23.4483 12.1081C23.5288 12.2699 23.5747 12.4465 23.5829 12.6268C23.5911 12.8071 23.5616 12.9871 23.4962 13.1555C23.4308 13.3238 23.331 13.4768 23.2029 13.6046L21.6061 15.1963ZM17.2574 13.8167C17.1007 13.576 17.0167 13.2956 17.015 13.0086L19.7671 15.4865C19.1886 15.0443 18.5619 14.6687 17.8987 14.3669C17.6365 14.2484 17.414 14.0575 17.2574 13.8167ZM24.1327 10.4353L24.1327 10.4353C22.1411 8.83136 19.7989 7.71723 17.2955 7.18294C16.1033 6.91886 14.5154 6.8 12.9894 6.8C11.4635 6.8 9.8757 6.91884 8.68356 7.18287C6.19054 7.71375 3.85696 8.81963 1.87004 10.4119L1.85021 10.4281C1.85021 10.4281 1.85021 10.4281 1.85021 10.4281C1.53782 10.6878 1.28325 11.0098 1.10285 11.3734C0.922454 11.737 0.820216 12.1341 0.802706 12.5394C0.785197 12.9447 0.852804 13.3492 1.00118 13.7269C1.14919 14.1037 1.3743 14.4455 1.66212 14.7307L1.66218 14.7307L1.6637 14.7322L1.66419 14.7327L3.24674 16.3101C3.73933 16.819 4.40091 17.1318 5.10809 17.1901C5.82205 17.2489 6.53286 17.0442 7.10537 16.6146L7.10608 16.6141L7.11481 16.6075L7.11553 16.6069C7.609 16.2297 8.14369 15.9093 8.70941 15.6518C9.21705 15.4217 9.64814 15.0516 9.95165 14.5851C10.2556 14.1179 10.4189 13.5735 10.422 13.0165L10.422 13.016L10.422 13.0092V13.0086V12.8136C11.1794 12.7034 12.0797 12.643 13.0106 12.643C13.9416 12.643 14.8419 12.7034 15.5993 12.8136L15.5993 13.0086L15.5993 13.0092L15.5993 13.016L15.5993 13.0165C15.6024 13.5735 15.7657 14.1179 16.0696 14.5851C16.3733 15.0519 16.8047 15.4221 17.3127 15.6521C17.8781 15.9096 18.4125 16.2299 18.9058 16.6069L18.9065 16.6075L18.9155 16.6143L18.9162 16.6148C19.4827 17.0396 20.1848 17.2446 20.8915 17.1915C21.5955 17.1387 22.2565 16.8335 22.7522 16.3324C22.7524 16.3323 22.7526 16.3321 22.7527 16.3319L24.3459 14.7439L24.3461 14.7437C24.6326 14.4576 24.8563 14.1151 25.0028 13.7379C25.1493 13.3608 25.2154 12.9574 25.197 12.5534C25.1785 12.1494 25.0758 11.7536 24.8955 11.3914C24.7152 11.0291 24.4613 10.7083 24.1498 10.4493L24.1327 10.4353Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="0.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

PhoneEndIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const PhoneIcon = (props) => {
    const theme = useTheme();
    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21.9999 16.92V19.92C22.0011 20.1985 21.944 20.4741 21.8324 20.7293C21.7209 20.9845 21.5572 21.2136 21.352 21.4018C21.1468 21.5901 20.9045 21.7335 20.6407 21.8227C20.3769 21.9119 20.0973 21.945 19.8199 21.92C16.7428 21.5856 13.7869 20.5341 11.1899 18.85C8.77376 17.3146 6.72527 15.2661 5.18993 12.85C3.49991 10.2412 2.44818 7.27097 2.11993 4.17997C2.09494 3.90344 2.12781 3.62474 2.21643 3.3616C2.30506 3.09846 2.4475 2.85666 2.6347 2.6516C2.82189 2.44653 3.04974 2.28268 3.30372 2.1705C3.55771 2.05831 3.83227 2.00024 4.10993 1.99997H7.10993C7.59524 1.9952 8.06572 2.16705 8.43369 2.48351C8.80166 2.79996 9.04201 3.23942 9.10993 3.71997C9.23656 4.68004 9.47138 5.6227 9.80993 6.52997C9.94448 6.8879 9.9736 7.27689 9.89384 7.65086C9.81408 8.02482 9.6288 8.36809 9.35993 8.63998L8.08993 9.90997C9.51349 12.4135 11.5864 14.4864 14.0899 15.91L15.3599 14.64C15.6318 14.3711 15.9751 14.1858 16.3491 14.1061C16.723 14.0263 17.112 14.0554 17.4699 14.19C18.3772 14.5285 19.3199 14.7634 20.2799 14.89C20.7657 14.9585 21.2093 15.2032 21.5265 15.5775C21.8436 15.9518 22.0121 16.4296 21.9999 16.92Z"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

PhoneIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const VideoIcon = (props) => {
    const theme = useTheme();
    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.4576 6.11084C23.7907 6.28224 24 6.62542 24 7V17C24 17.3746 23.7907 17.7178 23.4576 17.8892C23.1245 18.0606 22.7236 18.0315 22.4188 17.8137L15.4188 12.8137C15.156 12.626 15 12.323 15 12C15 11.6771 15.156 11.374 15.4188 11.1863L22.4188 6.18627C22.7236 5.96855 23.1245 5.93943 23.4576 6.11084ZM17.7205 12L22 15.0568V8.94319L17.7205 12Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 6C2.44772 6 2 6.44772 2 7V17C2 17.5523 2.44772 18 3 18H14C14.5523 18 15 17.5523 15 17V7C15 6.44772 14.5523 6 14 6H3ZM0 7C0 5.34315 1.34315 4 3 4H14C15.6569 4 17 5.34315 17 7V17C17 18.6569 15.6569 20 14 20H3C1.34315 20 0 18.6569 0 17V7Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

VideoIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const VideoOffIcon = (props) => {
    const theme = useTheme();
    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3 6C2.73478 6 2.48043 6.10536 2.29289 6.29289C2.10536 6.48043 2 6.73478 2 7V17C2 17.2652 2.10536 17.5196 2.29289 17.7071C2.48043 17.8946 2.73478 18 3 18H14C14.2652 18 14.5196 17.8946 14.7071 17.7071C14.8946 17.5196 15 17.2652 15 17V16.4142L4.58579 6H3ZM0.87868 4.87868C1.44129 4.31607 2.20435 4 3 4H5C5.26522 4 5.51957 4.10536 5.70711 4.29289L16.7071 15.2929C16.8946 15.4804 17 15.7348 17 16V17C17 17.7957 16.6839 18.5587 16.1213 19.1213C15.5587 19.6839 14.7957 20 14 20H3C2.20435 20 1.44129 19.6839 0.87868 19.1213C0.316071 18.5587 0 17.7956 0 17V7C0 6.20435 0.316071 5.44129 0.87868 4.87868ZM14 6H10.66C10.1077 6 9.66 5.55228 9.66 5C9.66 4.44772 10.1077 4 10.66 4H14C14.7956 4 15.5587 4.31607 16.1213 4.87868C16.6839 5.44129 17 6.20435 17 7V9.92579L17.1045 10.0303L22.4139 6.18975C22.7183 5.96958 23.1204 5.93857 23.4549 6.10947C23.7895 6.28037 24 6.62434 24 7V17C24 17.5523 23.5523 18 23 18C22.4477 18 22 17.5523 22 17V8.95752L17.5861 12.1503C17.1882 12.4381 16.6402 12.3944 16.2929 12.0471L15.2929 11.0471C15.1054 10.8596 15 10.6052 15 10.34V7C15 6.73478 14.8946 6.48043 14.7071 6.29289C14.5196 6.10536 14.2652 6 14 6Z"
                    fill={props.fill ? theme.palette.common[props.fill] : 'white'}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L23.7071 22.2929C24.0976 22.6834 24.0976 23.3166 23.7071 23.7071C23.3166 24.0976 22.6834 24.0976 22.2929 23.7071L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                    fill={props.fill ? theme.palette.common[props.fill] : 'white'}
                />
            </g>
            <defs>
                <clipPath id="clip0">
                    <rect
                        width="24"
                        height="24"
                        fill={props.fill ? theme.palette.common[props.fill] : 'white'}
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

VideoOffIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const BackIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width={props.width ? props.width : '8'}
            height={props.height ? props.height : '14'}
            viewBox="0 0 8 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.70711 0.292893C8.09763 0.683417 8.09763 1.31658 7.70711 1.70711L2.41421 7L7.70711 12.2929C8.09763 12.6834 8.09763 13.3166 7.70711 13.7071C7.31658 14.0976 6.68342 14.0976 6.29289 13.7071L0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289L6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'black'}
            />
        </svg>
    );
};

BackIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const NextIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

NextIcon.propTypes = {
    fill: PropTypes.string,
};

export const NoticeIcon = (props) => {
    const theme = useTheme();
    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.05025 3.05025C8.36301 1.7375 10.1435 1 12 1C13.8565 1 15.637 1.7375 16.9497 3.05025C18.2625 4.36301 19 6.14349 19 8C19 11.3527 19.7171 13.4346 20.3779 14.6461C20.7097 15.2544 21.0328 15.6535 21.2572 15.8904C21.3697 16.0091 21.4581 16.0878 21.5113 16.1322C21.5379 16.1544 21.5558 16.168 21.5635 16.1737C21.5647 16.1746 21.5656 16.1753 21.5663 16.1758C21.9248 16.4221 22.0834 16.8725 21.9571 17.2898C21.8294 17.7115 21.4407 18 21 18H3C2.55933 18 2.17061 17.7115 2.04291 17.2898C1.91657 16.8725 2.0752 16.4221 2.43369 16.1758C2.43439 16.1753 2.43535 16.1746 2.43655 16.1737C2.44425 16.168 2.4621 16.1544 2.48872 16.1322C2.54194 16.0878 2.63032 16.0091 2.7428 15.8904C2.96723 15.6535 3.29031 15.2544 3.6221 14.6461C4.28293 13.4346 5 11.3527 5 8C5 6.14348 5.7375 4.36301 7.05025 3.05025ZM2.4438 16.169C2.44388 16.1689 2.44395 16.1688 2.44403 16.1688C2.44403 16.1688 2.44402 16.1688 2.44402 16.1688L2.4438 16.169ZM5.14932 16H18.8507C18.7746 15.8753 18.6982 15.7434 18.6221 15.6039C17.7829 14.0654 17 11.6473 17 8C17 6.67392 16.4732 5.40215 15.5355 4.46447C14.5979 3.52678 13.3261 3 12 3C10.6739 3 9.40215 3.52678 8.46447 4.46447C7.52678 5.40215 7 6.67392 7 8C7 11.6473 6.21707 14.0654 5.3779 15.6039C5.3018 15.7434 5.22541 15.8753 5.14932 16Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.76823 20.135C10.246 19.8579 10.8579 20.0205 11.135 20.4983C11.2229 20.6498 11.3491 20.7756 11.5009 20.863C11.6527 20.9505 11.8248 20.9965 12 20.9965C12.1752 20.9965 12.3473 20.9505 12.4991 20.863C12.6509 20.7756 12.7771 20.6498 12.865 20.4983C13.1421 20.0205 13.754 19.8579 14.2318 20.135C14.7095 20.4122 14.8721 21.0241 14.595 21.5018C14.3313 21.9564 13.9528 22.3338 13.4973 22.5961C13.0419 22.8584 12.5256 22.9965 12 22.9965C11.4744 22.9965 10.9581 22.8584 10.5027 22.5961C10.0472 22.3338 9.66872 21.9564 9.405 21.5018C9.12788 21.0241 9.2905 20.4122 9.76823 20.135Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

NoticeIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const NoticeIcon2 = (props) => {
    const theme = useTheme();
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 6.44V9.77"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M12.0199 2C8.3399 2 5.3599 4.98 5.3599 8.66V10.76C5.3599 11.44 5.0799 12.46 4.7299 13.04L3.4599 15.16C2.6799 16.47 3.2199 17.93 4.6599 18.41C9.4399 20 14.6099 20 19.3899 18.41C20.7399 17.96 21.3199 16.38 20.5899 15.16L19.3199 13.04C18.9699 12.46 18.6899 11.43 18.6899 10.76V8.66C18.6799 5 15.6799 2 12.0199 2Z"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M15.3299 18.82C15.3299 20.65 13.8299 22.15 11.9999 22.15C11.0899 22.15 10.2499 21.77 9.64992 21.17C9.04992 20.57 8.66992 19.73 8.66992 18.82"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeMiterlimit="10"
            />
        </svg>
    );
};

NoticeIcon2.propTypes = {
    fill: PropTypes.string,
};

export const ArticleIcon = (props) => {
    const theme = useTheme();
    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.87868 3.87868C2.44129 3.31607 3.20435 3 4 3H11C11.5523 3 12 3.44772 12 4C12 4.55228 11.5523 5 11 5H4C3.73478 5 3.48043 5.10536 3.29289 5.29289C3.10536 5.48043 3 5.73478 3 6V20C3 20.2652 3.10536 20.5196 3.29289 20.7071C3.48043 20.8946 3.73478 21 4 21H18C18.2652 21 18.5196 20.8946 18.7071 20.7071C18.8946 20.5196 19 20.2652 19 20V13C19 12.4477 19.4477 12 20 12C20.5523 12 21 12.4477 21 13V20C21 20.7957 20.6839 21.5587 20.1213 22.1213C19.5587 22.6839 18.7957 23 18 23H4C3.20435 23 2.44129 22.6839 1.87868 22.1213C1.31607 21.5587 1 20.7957 1 20V6C1 5.20435 1.31607 4.44129 1.87868 3.87868Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 2.87866C19.7026 2.87866 19.4174 2.9968 19.2071 3.20709L9.90299 12.5112L9.37439 14.6256L11.4888 14.097L20.7929 4.79288C21.0032 4.58259 21.1213 4.29737 21.1213 3.99998C21.1213 3.70259 21.0032 3.41738 20.7929 3.20709C20.5826 2.9968 20.2974 2.87866 20 2.87866ZM17.7929 1.79288C18.3783 1.20751 19.1722 0.878662 20 0.878662C20.8278 0.878662 21.6218 1.20751 22.2071 1.79288C22.7925 2.37824 23.1213 3.17216 23.1213 3.99998C23.1213 4.82781 22.7925 5.62173 22.2071 6.20709L12.7071 15.7071C12.579 15.8352 12.4184 15.9262 12.2426 15.9701L8.24256 16.9701C7.90178 17.0553 7.54129 16.9555 7.29291 16.7071C7.04453 16.4587 6.94468 16.0982 7.02988 15.7574L8.02988 11.7574C8.07384 11.5816 8.16476 11.421 8.29291 11.2929L17.7929 1.79288Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

ArticleIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const CheckboxIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z"
                fill={props.fill ? theme.palette.common[props.fill] : '#FE5D83'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.4839 4.21448C12.857 4.54118 12.907 5.12328 12.5955 5.51464L7.69815 11.6685C7.53671 11.8713 7.30012 11.9919 7.04831 11.9996C6.79649 12.0073 6.55359 11.9015 6.38113 11.7088L4.23853 9.31568C3.90582 8.94407 3.9233 8.3599 4.27758 8.0109C4.63185 7.6619 5.18876 7.68024 5.52147 8.05186L6.98383 9.68523L11.2444 4.33155C11.5559 3.94019 12.1108 3.88778 12.4839 4.21448Z"
                fill="white"
            />
        </svg>
    );
};

CheckboxIcon.propTypes = {
    fill: PropTypes.string,
};

export const CheckboxBlankIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="0.5"
                y="0.5"
                width="15"
                height="15"
                rx="3.5"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
                stroke="#848CB7"
            />
        </svg>
    );
};

CheckboxBlankIcon.propTypes = {
    fill: PropTypes.string,
};

export const DeleteIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 6C2 5.44772 2.44772 5 3 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 3C9.73478 3 9.48043 3.10536 9.29289 3.29289C9.10536 3.48043 9 3.73478 9 4V5H15V4C15 3.73478 14.8946 3.48043 14.7071 3.29289C14.5196 3.10536 14.2652 3 14 3H10ZM17 5V4C17 3.20435 16.6839 2.44129 16.1213 1.87868C15.5587 1.31607 14.7956 1 14 1H10C9.20435 1 8.44129 1.31607 7.87868 1.87868C7.31607 2.44129 7 3.20435 7 4V5H5C4.44772 5 4 5.44772 4 6V20C4 20.7957 4.31607 21.5587 4.87868 22.1213C5.44129 22.6839 6.20435 23 7 23H17C17.7957 23 18.5587 22.6839 19.1213 22.1213C19.6839 21.5587 20 20.7957 20 20V6C20 5.44772 19.5523 5 19 5H17ZM6 7V20C6 20.2652 6.10536 20.5196 6.29289 20.7071C6.48043 20.8946 6.73478 21 7 21H17C17.2652 21 17.5196 20.8946 17.7071 20.7071C17.8946 20.5196 18 20.2652 18 20V7H6Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 10C10.5523 10 11 10.4477 11 11V17C11 17.5523 10.5523 18 10 18C9.44772 18 9 17.5523 9 17V11C9 10.4477 9.44772 10 10 10Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14 10C14.5523 10 15 10.4477 15 11V17C15 17.5523 14.5523 18 14 18C13.4477 18 13 17.5523 13 17V11C13 10.4477 13.4477 10 14 10Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

DeleteIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const DeleteIcon2 = (props) => {
    const theme = useTheme();

    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="Iconly/Light/Delete">
                <g id="Delete">
                    <path
                        id="Stroke 1"
                        d="M14.4938 7.10114C14.4938 7.10114 14.0866 12.1524 13.8503 14.2801C13.7378 15.2964 13.1101 15.8919 12.0818 15.9106C10.1251 15.9459 8.16609 15.9481 6.21009 15.9069C5.22084 15.8866 4.60359 15.2836 4.49334 14.2854C4.25559 12.1389 3.85059 7.10114 3.85059 7.10114"
                        stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Stroke 3"
                        d="M15.5312 4.67978H2.81274"
                        stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        id="Stroke 5"
                        d="M13.0804 4.67977C12.4917 4.67977 11.9847 4.26352 11.8692 3.68677L11.6869 2.77477C11.5744 2.35402 11.1934 2.06302 10.7592 2.06302H7.58443C7.15018 2.06302 6.76918 2.35402 6.65668 2.77477L6.47443 3.68677C6.35893 4.26352 5.85193 4.67977 5.26318 4.67977"
                        stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
            </g>
        </svg>
    );
};

DeleteIcon2.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const PlusCircleIcon = (props) => {
    const theme = useTheme();
    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 7C12.5523 7 13 7.44772 13 8V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V8C11 7.44772 11.4477 7 12 7Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 12C7 11.4477 7.44772 11 8 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H8C7.44772 13 7 12.5523 7 12Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

PlusCircleIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const GroupIcon = (props) => {
    const theme = useTheme();
    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.46447 15.4645C2.40215 14.5268 3.67392 14 5 14H13C14.3261 14 15.5979 14.5268 16.5355 15.4645C17.4732 16.4021 18 17.6739 18 19V21C18 21.5523 17.5523 22 17 22C16.4477 22 16 21.5523 16 21V19C16 18.2044 15.6839 17.4413 15.1213 16.8787C14.5587 16.3161 13.7956 16 13 16H5C4.20435 16 3.44129 16.3161 2.87868 16.8787C2.31607 17.4413 2 18.2044 2 19V21C2 21.5523 1.55228 22 1 22C0.447715 22 0 21.5523 0 21V19C0 17.6739 0.526784 16.4021 1.46447 15.4645Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 4C7.34315 4 6 5.34315 6 7C6 8.65685 7.34315 10 9 10C10.6569 10 12 8.65685 12 7C12 5.34315 10.6569 4 9 4ZM4 7C4 4.23858 6.23858 2 9 2C11.7614 2 14 4.23858 14 7C14 9.76142 11.7614 12 9 12C6.23858 12 4 9.76142 4 7Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.032 14.88C19.1701 14.3453 19.7155 14.0237 20.2502 14.1618C21.3229 14.4387 22.2732 15.0641 22.9519 15.9397C23.6307 16.8152 23.9994 17.8914 24.0002 18.9993L24.0002 21C24.0002 21.5523 23.5525 22 23.0002 22C22.448 22 22.0002 21.5523 22.0002 21L22.0002 19.0007C22.0002 19.0006 22.0002 19.0008 22.0002 19.0007C21.9997 18.3361 21.7784 17.6902 21.3713 17.165C20.964 16.6396 20.3938 16.2644 19.7502 16.0982C19.2155 15.9602 18.8939 15.4148 19.032 14.88Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.0315 2.88196C15.1685 2.34694 15.7133 2.02426 16.2483 2.16125C17.3238 2.43663 18.2771 3.06213 18.9578 3.93914C19.6386 4.81615 20.0081 5.89479 20.0081 7.005C20.0081 8.11521 19.6386 9.19385 18.9578 10.0709C18.2771 10.9479 17.3238 11.5734 16.2483 11.8488C15.7133 11.9857 15.1685 11.6631 15.0315 11.128C14.8945 10.593 15.2172 10.0482 15.7522 9.91125C16.3975 9.74603 16.9695 9.37073 17.3779 8.84452C17.7864 8.31831 18.0081 7.67113 18.0081 7.005C18.0081 6.33887 17.7864 5.69169 17.3779 5.16548C16.9695 4.63928 16.3975 4.26398 15.7522 4.09875C15.2172 3.96176 14.8945 3.41699 15.0315 2.88196Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

GroupIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const GroupIcon2 = (props) => {
    const theme = useTheme();

    return (
        <svg
            width={props.width ? props.width : '37'}
            height={props.height ? props.height : '37'}
            viewBox="0 0 37 37"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.1217 16.7576C13.9675 16.7422 13.7825 16.7422 13.6129 16.7576C9.94375 16.6343 7.03 13.628 7.03 9.92801C7.03 6.15092 10.0825 3.08301 13.875 3.08301C17.6521 3.08301 20.72 6.15092 20.72 9.92801C20.7046 13.628 17.7908 16.6343 14.1217 16.7576Z"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25.2987 6.16699C28.2896 6.16699 30.6946 8.58741 30.6946 11.5628C30.6946 14.4766 28.3821 16.8507 25.4992 16.9587C25.3758 16.9432 25.2371 16.9432 25.0983 16.9587"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.41333 22.447C2.6825 24.9445 2.6825 29.0145 6.41333 31.4966C10.6529 34.3332 17.6058 34.3332 21.8454 31.4966C25.5762 28.9991 25.5762 24.9291 21.8454 22.447C17.6212 19.6257 10.6683 19.6257 6.41333 22.447Z"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.2742 30.833C29.3842 30.6018 30.4325 30.1547 31.2958 29.4918C33.7008 27.688 33.7008 24.7126 31.2958 22.9088C30.4479 22.2613 29.415 21.8297 28.3204 21.583"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

GroupIcon2.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const DropdownIcon = (props) => {
    const theme = useTheme();
    return (
        <svg
            width={props.width ? props.width : '15'}
            height={props.height ? props.height : '15'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.29289 7.29289C3.68342 6.90237 4.31658 6.90237 4.70711 7.29289L12 14.5858L19.2929 7.29289C19.6834 6.90237 20.3166 6.90237 20.7071 7.29289C21.0976 7.68342 21.0976 8.31658 20.7071 8.70711L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L3.29289 8.70711C2.90237 8.31658 2.90237 7.68342 3.29289 7.29289Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

DropdownIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const SuccessIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.663 3.77342C13.8902 2.98352 11.9096 2.78783 10.0166 3.21555C8.12351 3.64326 6.41942 4.67145 5.15845 6.14678C3.89749 7.62211 3.14721 9.46552 3.01951 11.4021C2.89181 13.3387 3.39354 15.2646 4.44987 16.8928C5.50619 18.5209 7.06051 19.764 8.88102 20.4365C10.7015 21.1091 12.6907 21.1752 14.5518 20.6249C16.413 20.0746 18.0464 18.9375 19.2084 17.3831C20.3705 15.8286 20.9989 13.9402 21 11.9994V11.08C21 10.5277 21.4477 10.08 22 10.08C22.5523 10.08 23 10.5277 23 11.08V12C22.9986 14.3721 22.2306 16.6807 20.8103 18.5806C19.39 20.4804 17.3936 21.8703 15.1189 22.5428C12.8442 23.2154 10.413 23.1346 8.18792 22.3126C5.96285 21.4906 4.06312 19.9713 2.77206 17.9813C1.48099 15.9914 0.86777 13.6374 1.02384 11.2705C1.17992 8.90358 2.09693 6.65052 3.63811 4.84734C5.17929 3.04416 7.26206 1.78748 9.57581 1.26472C11.8896 0.74196 14.3103 0.981129 16.477 1.94656C16.9815 2.17134 17.2082 2.76252 16.9834 3.26699C16.7587 3.77146 16.1675 3.9982 15.663 3.77342Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.7068 3.29254C23.0975 3.68287 23.0978 4.31603 22.7075 4.70675L12.7075 14.7168C12.52 14.9044 12.2656 15.0099 12.0002 15.01C11.7349 15.0101 11.4805 14.9047 11.2929 14.7171L8.29289 11.7171C7.90237 11.3266 7.90237 10.6934 8.29289 10.3029C8.68342 9.91237 9.31658 9.91237 9.70711 10.3029L11.9996 12.5954L21.2925 3.29325C21.6829 2.90253 22.316 2.90221 22.7068 3.29254Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

SuccessIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const ErrorIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.528 2.28312C10.9773 2.03017 11.4842 1.89728 11.9998 1.89728C12.5154 1.89728 13.0223 2.03017 13.4716 2.28312C13.9209 2.53607 14.2974 2.90055 14.5648 3.34139L14.5677 3.34614L23.0376 17.4862L23.0458 17.5C23.3077 17.9536 23.4463 18.4679 23.4478 18.9917C23.4493 19.5156 23.3135 20.0307 23.0541 20.4858C22.7947 20.9408 22.4207 21.3201 21.9692 21.5857C21.5177 21.8514 21.0046 21.9942 20.4808 22L20.4698 22.0001L3.51879 22C2.99498 21.9943 2.48182 21.8514 2.03035 21.5857C1.57887 21.3201 1.20483 20.9408 0.945426 20.4858C0.686022 20.0307 0.550303 19.5156 0.55177 18.9917C0.553236 18.4679 0.691839 17.9536 0.953786 17.5L0.961909 17.4862L9.43191 3.34615L10.2898 3.86001L9.43478 3.34139C9.70218 2.90055 10.0787 2.53607 10.528 2.28312ZM11.146 4.37666L2.68246 18.5058C2.59729 18.6556 2.55224 18.8249 2.55176 18.9973C2.55127 19.172 2.59651 19.3436 2.68298 19.4953C2.76945 19.647 2.89413 19.7735 3.04462 19.862C3.1938 19.9498 3.36317 19.9973 3.53617 20H20.4634C20.6364 19.9973 20.8058 19.9498 20.9549 19.862C21.1054 19.7735 21.2301 19.647 21.3166 19.4953C21.403 19.3436 21.4483 19.172 21.4478 18.9973C21.4473 18.825 21.4023 18.6557 21.3171 18.5059L12.8548 4.37865C12.8544 4.37799 12.854 4.37732 12.8536 4.37666C12.7645 4.23061 12.6395 4.10983 12.4904 4.02589C12.3406 3.94157 12.1716 3.89728 11.9998 3.89728C11.8279 3.89728 11.6589 3.94157 11.5092 4.02589C11.3601 4.10983 11.235 4.23061 11.146 4.37666Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 8C12.5523 8 13 8.44772 13 9V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V9C11 8.44772 11.4477 8 12 8Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 15C12.5523 15 13 15.4477 13 16V16.5C13 17.0523 12.5523 17.5 12 17.5C11.4477 17.5 11 17.0523 11 16.5V16C11 15.4477 11.4477 15 12 15Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

ErrorIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const SearchIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4ZM2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.9433 15.9429C16.3338 15.5524 16.967 15.5524 17.3575 15.9429L21.7075 20.2929C22.098 20.6834 22.098 21.3166 21.7075 21.7071C21.317 22.0977 20.6838 22.0977 20.2933 21.7071L15.9433 17.3571C15.5528 16.9666 15.5528 16.3334 15.9433 15.9429Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

SearchIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const CrossIcon = (props) => {
    const theme = useTheme();
    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

CrossIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const StarIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 1C12.3806 1 12.7283 1.21607 12.8967 1.55738L15.7543 7.34647L22.1447 8.28051C22.5212 8.33555 22.8339 8.59956 22.9513 8.96157C23.0687 9.32358 22.9704 9.72083 22.6978 9.98636L18.0746 14.4894L19.1656 20.851C19.23 21.2261 19.0757 21.6053 18.7678 21.8291C18.4598 22.0528 18.0515 22.0823 17.7146 21.9051L12 18.8998L6.28548 21.9051C5.94856 22.0823 5.54027 22.0528 5.2323 21.8291C4.92432 21.6053 4.77007 21.2261 4.83442 20.851L5.92551 14.4894L1.3023 9.98636C1.02968 9.72083 0.931405 9.32358 1.04878 8.96157C1.16616 8.59956 1.47884 8.33555 1.8554 8.28051L8.24577 7.34647L11.1033 1.55738C11.2718 1.21607 11.6194 1 12 1ZM12 4.25925L9.80674 8.70262C9.6612 8.99747 9.38001 9.20193 9.05466 9.24949L4.14844 9.9666L7.69776 13.4236C7.93364 13.6534 8.0413 13.9845 7.98564 14.309L7.14821 19.1917L11.5346 16.8849C11.826 16.7317 12.1741 16.7317 12.4655 16.8849L16.8518 19.1917L16.0144 14.309C15.9588 13.9845 16.0664 13.6534 16.3023 13.4236L19.8516 9.9666L14.9454 9.24949C14.62 9.20193 14.3389 8.99747 14.1933 8.70262L12 4.25925Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

StarIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const CameraIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.16795 2.4453C8.35342 2.1671 8.66565 2 9 2H15C15.3344 2 15.6466 2.1671 15.8321 2.4453L17.5352 5H21C21.7957 5 22.5587 5.31607 23.1213 5.87868C23.6839 6.44129 24 7.20435 24 8V19C24 19.7957 23.6839 20.5587 23.1213 21.1213C22.5587 21.6839 21.7957 22 21 22H3C2.20435 22 1.44129 21.6839 0.87868 21.1213C0.316071 20.5587 0 19.7957 0 19V8C0 7.20435 0.316071 6.44129 0.87868 5.87868C1.44129 5.31607 2.20435 5 3 5H6.46482L8.16795 2.4453ZM9.53518 4L7.83205 6.5547C7.64658 6.8329 7.33435 7 7 7H3C2.73478 7 2.48043 7.10536 2.29289 7.29289C2.10536 7.48043 2 7.73478 2 8V19C2 19.2652 2.10536 19.5196 2.29289 19.7071C2.48043 19.8946 2.73478 20 3 20H21C21.2652 20 21.5196 19.8946 21.7071 19.7071C21.8946 19.5196 22 19.2652 22 19V8C22 7.73478 21.8946 7.48043 21.7071 7.29289C21.5196 7.10536 21.2652 7 21 7H17C16.6656 7 16.3534 6.8329 16.1679 6.5547L14.4648 4H9.53518Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16C13.6569 16 15 14.6569 15 13C15 11.3431 13.6569 10 12 10ZM7 13C7 10.2386 9.23858 8 12 8C14.7614 8 17 10.2386 17 13C17 15.7614 14.7614 18 12 18C9.23858 18 7 15.7614 7 13Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

CameraIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const MessagesIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.9833 8.99167V12.325C14.9833 12.5417 14.975 12.75 14.95 12.95C14.7583 15.2 13.4333 16.3167 10.9916 16.3167H10.6583C10.45 16.3167 10.25 16.4167 10.125 16.5833L9.12497 17.9167C8.6833 18.5083 7.96663 18.5083 7.52496 17.9167L6.52495 16.5833C6.41662 16.4417 6.17496 16.3167 5.99163 16.3167H5.6583C2.99997 16.3167 1.66663 15.6583 1.66663 12.325V8.99167C1.66663 6.55001 2.79163 5.22501 5.0333 5.03334C5.2333 5.00834 5.44163 5 5.6583 5H10.9916C13.65 5 14.9833 6.33334 14.9833 8.99167Z"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.3167 5.65818V8.99151C18.3167 11.4415 17.1917 12.7582 14.95 12.9498C14.975 12.7498 14.9833 12.5415 14.9833 12.3248V8.99151C14.9833 6.33318 13.65 4.99984 10.9917 4.99984H5.65833C5.44166 4.99984 5.23333 5.00818 5.03333 5.03318C5.22499 2.79151 6.54999 1.6665 8.99166 1.6665H14.325C16.9833 1.6665 18.3167 2.99984 18.3167 5.65818Z"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.2463 11.0417H11.2538"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.32954 11.0417H8.33704"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.41292 11.0417H5.42042"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

MessagesIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const MessageIcon2 = (props) => {
    const theme = useTheme();

    return (
        <svg
            width={props.width ? props.width : '28'}
            height={props.height ? props.height : '28'}
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M19.7065 10.576C19.7065 14.9929 15.8717 18.5652 11.1467 18.5652L10.0853 19.8434L9.45757 20.5967C8.92116 21.2359 7.89397 21.0989 7.54017 20.3342L6.01083 16.9673C3.93365 15.5065 2.58691 13.1896 2.58691 10.576C2.58691 6.1592 6.4217 2.58691 11.1467 2.58691C14.5934 2.58691 17.5722 4.4929 18.9076 7.23203C19.4212 8.24779 19.7065 9.37768 19.7065 10.576Z"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25.4129 14.9819C25.4129 17.5954 24.0662 19.9123 21.989 21.3732L20.4597 24.74C20.1059 25.5047 19.0787 25.6531 18.5423 25.0025L16.8531 22.971C14.0912 22.971 11.626 21.7498 10.0852 19.8438L11.1466 18.5656C15.8716 18.5656 19.7064 14.9933 19.7064 10.5764C19.7064 9.37807 19.4211 8.24818 18.9075 7.23242C22.6395 8.0884 25.4129 11.2384 25.4129 14.9819Z"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.31506 10.0869L7.15206 10.576"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.3912 10.0869L11.2282 10.576"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.4673 10.0869L15.3043 10.576"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

MessageIcon2.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const MessageIcon3 = (props) => {
    const theme = useTheme();

    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.08341 15.8332H6.66675C3.33341 15.8332 1.66675 14.9998 1.66675 10.8332V6.6665C1.66675 3.33317 3.33341 1.6665 6.66675 1.6665H13.3334C16.6667 1.6665 18.3334 3.33317 18.3334 6.6665V10.8332C18.3334 14.1665 16.6667 15.8332 13.3334 15.8332H12.9167C12.6584 15.8332 12.4084 15.9582 12.2501 16.1665L11.0001 17.8332C10.4501 18.5665 9.55008 18.5665 9.00008 17.8332L7.75008 16.1665C7.61675 15.9832 7.30841 15.8332 7.08341 15.8332Z"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.83325 6.6665H14.1666"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.83325 10.8335H10.8333"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

MessageIcon3.propTypes = {
    fill: PropTypes.string,
};

export const HappyIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.12192 13C2.12192 7.01146 6.97656 2.15682 12.9651 2.15682C18.9536 2.15682 23.8082 7.01146 23.8082 13C23.8082 18.9885 18.9536 23.8431 12.9651 23.8431C6.97656 23.8431 2.12192 18.9885 2.12192 13ZM12.9651 0.509766C6.06689 0.509766 0.474854 6.10182 0.474854 13C0.474854 19.8981 6.06689 25.4902 12.9651 25.4902C19.8632 25.4902 25.4553 19.8981 25.4553 13C25.4553 6.10182 19.8632 0.509766 12.9651 0.509766ZM8.0878 15.8239C7.82816 15.4505 7.31494 15.3583 6.9415 15.618C6.56808 15.8776 6.47589 16.3908 6.73553 16.7642C8.1088 18.7391 10.4106 20.0343 13 20.0343C15.5916 20.0343 17.8793 18.7375 19.2624 16.7672C19.5237 16.395 19.4337 15.8814 19.0615 15.62C18.6892 15.3587 18.1756 15.4487 17.9143 15.8209C16.824 17.374 15.0284 18.3872 13 18.3872C10.9694 18.3872 9.16455 17.3724 8.0878 15.8239ZM11.0001 10.5C11.0001 11.3284 10.3285 12 9.50006 12C8.67163 12 8.00006 11.3284 8.00006 10.5C8.00006 9.67154 8.67163 8.99996 9.50006 8.99996C10.3285 8.99996 11.0001 9.67154 11.0001 10.5ZM16.5001 12C17.3285 12 18.0001 11.3284 18.0001 10.5C18.0001 9.67154 17.3285 8.99996 16.5001 8.99996C15.6716 8.99996 15.0001 9.67154 15.0001 10.5C15.0001 11.3284 15.6716 12 16.5001 12Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

HappyIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const CloseCircleIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width="46"
            height="46"
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M23 42.1666C33.5417 42.1666 42.1667 33.5416 42.1667 23C42.1667 12.4583 33.5417 3.83331 23 3.83331C12.4584 3.83331 3.83337 12.4583 3.83337 23C3.83337 33.5416 12.4584 42.1666 23 42.1666Z"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.5758 28.4241L28.4241 17.5758"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.4241 28.4241L17.5758 17.5758"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

CloseCircleIcon.propTypes = {
    fill: PropTypes.string,
};

export const WalletIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width={props.width ? props.width : '24'}
            height={props.height ? props.height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.04 13.55C17.62 13.96 17.38 14.55 17.44 15.18C17.53 16.26 18.52 17.05 19.6 17.05H21.5V18.24C21.5 20.31 19.81 22 17.74 22H6.26C4.19 22 2.5 20.31 2.5 18.24V11.51C2.5 9.44001 4.19 7.75 6.26 7.75H17.74C19.81 7.75 21.5 9.44001 21.5 11.51V12.95H19.48C18.92 12.95 18.41 13.17 18.04 13.55Z"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.5 12.4098V7.83986C2.5 6.64986 3.23 5.58982 4.34 5.16982L12.28 2.16982C13.52 1.69982 14.85 2.61985 14.85 3.94985V7.74983"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.5588 13.9702V16.0302C22.5588 16.5802 22.1188 17.0302 21.5588 17.0502H19.5988C18.5188 17.0502 17.5288 16.2602 17.4388 15.1802C17.3788 14.5502 17.6188 13.9602 18.0388 13.5502C18.4088 13.1702 18.9188 12.9502 19.4788 12.9502H21.5588C22.1188 12.9702 22.5588 13.4202 22.5588 13.9702Z"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7 12H14"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

WalletIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const ArrowRight = (props) => {
    const theme = useTheme();

    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.8225 4.44727L15.375 8.99977L10.8225 13.5523"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.625 9H15.2475"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

ArrowRight.propTypes = {
    fill: PropTypes.string,
};

export const InfoCirCleIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                stroke="#9A223E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 8V13"
                stroke="#9A223E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.9945 16H12.0035"
                stroke="#9A223E"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const InfoCirCleIcon2 = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="8" cy="8" r="7.25" stroke="#454A67" strokeWidth="1.5" />
            <path d="M8 8.66699L8 4.00033" stroke="#454A67" strokeWidth="1.5" />
            <path d="M8 12L8 9.33333" stroke="#454A67" strokeWidth="1.5" />
        </svg>
    );
};

export const EyeIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.14074 12C2.25003 12.1889 2.39492 12.4296 2.57441 12.7075C3.03543 13.4213 3.71817 14.3706 4.60454 15.3161C6.39552 17.2264 8.89951 19 12 19C15.1005 19 17.6045 17.2264 19.3955 15.3161C20.2818 14.3706 20.9646 13.4213 21.4256 12.7075C21.6051 12.4296 21.75 12.1889 21.8593 12C21.75 11.8111 21.6051 11.5704 21.4256 11.2925C20.9646 10.5787 20.2818 9.6294 19.3955 8.68394C17.6045 6.77356 15.1005 5 12 5C8.89951 5 6.39552 6.77356 4.60454 8.68394C3.71817 9.6294 3.03543 10.5787 2.57441 11.2925C2.39492 11.5704 2.25003 11.8111 2.14074 12ZM23 12C23.8944 11.5528 23.8943 11.5524 23.8941 11.5521L23.8925 11.5489L23.889 11.542L23.8777 11.5198C23.8681 11.5013 23.8546 11.4753 23.8372 11.4424C23.8025 11.3767 23.752 11.2832 23.686 11.166C23.5542 10.9316 23.3601 10.6015 23.1057 10.2075C22.5979 9.42131 21.8432 8.3706 20.8545 7.31606C18.8955 5.22644 15.8995 3 12 3C8.10049 3 5.10448 5.22644 3.14546 7.31606C2.15683 8.3706 1.40207 9.42131 0.894336 10.2075C0.63985 10.6015 0.445792 10.9316 0.313971 11.166C0.248023 11.2832 0.19754 11.3767 0.162753 11.4424C0.145357 11.4753 0.131875 11.5013 0.122338 11.5198L0.11099 11.542L0.107539 11.5489L0.10637 11.5512C0.106186 11.5516 0.105573 11.5528 1 12L0.105573 11.5528C-0.0351909 11.8343 -0.0351909 12.1657 0.105573 12.4472L1 12C0.105573 12.4472 0.105389 12.4468 0.105573 12.4472L0.107539 12.4511L0.11099 12.458L0.122338 12.4802C0.131875 12.4987 0.145357 12.5247 0.162753 12.5576C0.19754 12.6233 0.248023 12.7168 0.313971 12.834C0.445792 13.0684 0.63985 13.3985 0.894336 13.7925C1.40207 14.5787 2.15683 15.6294 3.14546 16.6839C5.10448 18.7736 8.10049 21 12 21C15.8995 21 18.8955 18.7736 20.8545 16.6839C21.8432 15.6294 22.5979 14.5787 23.1057 13.7925C23.3601 13.3985 23.5542 13.0684 23.686 12.834C23.752 12.7168 23.8025 12.6233 23.8372 12.5576C23.8546 12.5247 23.8681 12.4987 23.8777 12.4802L23.889 12.458L23.8925 12.4511L23.8936 12.4488C23.8938 12.4484 23.8944 12.4472 23 12ZM23 12L23.8944 12.4472C24.0352 12.1657 24.0348 11.8336 23.8941 11.5521L23 12Z"
                fill="#454A67"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10ZM8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12Z"
                fill="#454A67"
            />
        </svg>
    );
};

export const EyeOffIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_68_2365)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.0732 5.00035L20.7526 13.6877C21.1532 13.1462 21.5223 12.582 21.858 11.9978C21.7488 11.8093 21.6044 11.5694 21.4256 11.2926C20.9646 10.5787 20.2818 9.62943 19.3955 8.68397C17.6186 6.78864 15.1399 5.02799 12.0732 5.00035ZM23 12L23.8944 11.5528C24.0395 11.8429 24.0348 12.1854 23.8819 12.4714C23.2421 13.6684 22.479 14.7953 21.6052 15.8339C21.4247 16.0483 21.1627 16.1771 20.8827 16.1891C20.6027 16.2011 20.3306 16.095 20.1326 15.8968L9.19257 4.94681C8.93609 4.6901 8.83881 4.31458 8.93838 3.96563C9.03796 3.61668 9.31876 3.34905 9.67209 3.26634C10.4355 3.08765 11.2171 2.99828 12.0012 3.00003C12.0016 3.00003 12.002 3.00003 12.0023 3.00003L12 4.00003V3.00003C12.0004 3.00003 12.0008 3.00003 12.0012 3.00003C15.9001 3.00046 18.8957 5.22667 20.8545 7.31608C21.8432 8.37062 22.5979 9.42134 23.1057 10.2075C23.3601 10.6015 23.5542 10.9317 23.686 11.166C23.752 11.2833 23.8025 11.3767 23.8372 11.4425C23.8546 11.4753 23.8681 11.5013 23.8777 11.5198L23.889 11.5421L23.8925 11.5489L23.8944 11.5528C23.8946 11.5532 23.8944 11.5528 23 12ZM5.4531 5.26525C5.85123 4.96123 6.41289 4.9987 6.76711 5.35292L10.5832 9.16899C10.5855 9.1713 10.5878 9.17361 10.5901 9.17594L14.824 13.4098C14.8264 13.4122 14.8287 13.4145 14.8311 13.4169L18.6471 17.2329C18.8511 17.4369 18.9571 17.7191 18.9378 18.007C18.9184 18.2949 18.7757 18.5604 18.5462 18.7353C16.6671 20.1677 14.3789 20.9613 12.0163 20.9999L12 21C8.10049 21 5.10448 18.7736 3.14546 16.684C2.15683 15.6294 1.40207 14.5787 0.894336 13.7926C0.63985 13.3985 0.445792 13.0684 0.313971 12.834C0.248023 12.7168 0.19754 12.6233 0.162753 12.5576C0.145357 12.5247 0.131875 12.4988 0.122338 12.4802L0.11099 12.458L0.107539 12.4512L0.10637 12.4488C0.106186 12.4485 0.105573 12.4472 1 12L0.105573 12.4472C-0.0397387 12.1566 -0.0347895 11.8135 0.118844 11.5272C1.43015 9.08345 3.24891 6.94839 5.4531 5.26525ZM2.14257 12.0032C2.25165 12.1916 2.39592 12.4311 2.57441 12.7075C3.03543 13.4213 3.71817 14.3706 4.60454 15.3161C6.39395 17.2248 8.89512 18.9969 11.9918 19C13.5373 18.9734 15.0437 18.5524 16.3714 17.7856L14.0497 15.464C13.891 15.5635 13.7251 15.652 13.5531 15.7286C13.0625 15.9472 12.5328 16.0648 11.9957 16.0742C11.4586 16.0837 10.9252 15.9849 10.4271 15.7837C9.92902 15.5826 9.47657 15.2831 9.09674 14.9033C8.71691 14.5235 8.41747 14.071 8.21629 13.5729C8.01511 13.0749 7.91631 12.5414 7.92579 12.0043C7.93527 11.4672 8.05282 10.9375 8.27145 10.4469C8.34805 10.2749 8.43652 10.109 8.53604 9.95028L5.9871 7.40134C4.45031 8.7014 3.14935 10.2582 2.14257 12.0032ZM10.0279 11.4421C9.96372 11.6346 9.92907 11.836 9.92548 12.0396C9.92074 12.3081 9.97014 12.5749 10.0707 12.8239C10.1713 13.0729 10.321 13.2992 10.511 13.4891C10.7009 13.679 10.9271 13.8287 11.1761 13.9293C11.4252 14.0299 11.6919 14.0793 11.9604 14.0745C12.164 14.071 12.3655 14.0363 12.5579 13.9721L10.0279 11.4421Z"
                    fill="#454A67"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L23.7071 22.2929C24.0976 22.6834 24.0976 23.3166 23.7071 23.7071C23.3166 24.0976 22.6834 24.0976 22.2929 23.7071L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                    fill="#454A67"
                />
            </g>
            <defs>
                <clipPath id="clip0_68_2365">
                    <rect
                        width="24"
                        height="24"
                        fill={props.fill ? theme.palette.common[props.fill] : 'white'}
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

EyeOffIcon.propTypes = {
    fill: PropTypes.string,
};

export const SpeechIcon = () => {
    return (
        <svg
            width="25"
            height="16"
            viewBox="0 0 25 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.6476 5.48185C17.3152 5.19825 16.826 5.24817 16.5564 5.59762C16.2846 5.94608 16.3331 6.46026 16.6655 6.74576C17.03 7.0608 17.2402 7.51679 17.2402 7.96938C17.2402 8.45157 17.03 8.90824 16.6644 9.22267C16.332 9.50838 16.2835 10.0224 16.5552 10.3708C16.7078 10.5684 16.9309 10.6703 17.1553 10.6703C17.3281 10.6703 17.5029 10.6098 17.6465 10.4866C18.3751 9.88862 18.7922 8.97324 18.7922 7.96938C18.7922 6.96552 18.3751 6.10799 17.6476 5.48185ZM19.6037 2.97051C19.2733 2.68691 18.7844 2.73577 18.5115 3.08416C18.2397 3.43262 18.2882 3.9468 18.6197 4.23231C19.7169 5.14497 20.3442 6.54696 20.3442 7.96938C20.3442 9.39179 19.7156 10.7632 18.6205 11.7364C18.2891 12.0221 18.2406 12.5361 18.5124 12.8845C18.666 13.0811 18.8881 13.183 19.1125 13.183C19.2863 13.183 19.46 13.1225 19.6046 12.9982C21.0619 11.7738 21.8961 9.93966 21.8961 7.96938C21.8961 5.99909 21.0619 4.22278 19.6037 2.97051ZM21.5857 0.425132C21.2553 0.141533 20.7664 0.191454 20.4935 0.538789C20.2217 0.887246 20.2702 1.40143 20.6017 1.68693C22.4102 3.24614 23.4481 5.54651 23.4481 7.96938C23.4481 10.3922 22.4105 12.7232 20.6009 14.2818C20.2695 14.5675 20.221 15.0815 20.4928 15.4299C20.6448 15.6565 20.8679 15.7586 21.0943 15.7586C21.2681 15.7586 21.4419 15.6981 21.5864 15.5738C23.7553 13.7033 25.0001 10.9435 25.0001 7.96938C25.0001 4.99524 23.7553 2.29469 21.5857 0.425132Z"
                fill="#5F668C"
            />
            <path
                d="M14.5755 8.11282C13.9761 6.7638 13.1884 3.77066 12.4831 2.76598C11.3839 1.20285 9.5777 0.241394 7.61693 0.241394H5.49587C2.46026 0.241394 0 2.70157 0 5.73708C0 7.36289 0.709883 8.81982 1.83196 9.8245V12.8966C1.83196 14.0011 2.72739 14.8966 3.83196 14.8966H7.32788C8.33959 14.8966 9.15973 14.0764 9.15966 13.0647H10.9913C12.0029 13.0647 12.7975 12.2446 12.7975 11.2585V9.40088H13.7129C14.4009 9.40088 14.8446 8.71964 14.5755 8.11282Z"
                fill="#5F668C"
            />
        </svg>
    );
};

export const ArrowRightIcon = () => {
    return (
        <svg
            width="14"
            height="15"
            viewBox="0 0 14 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.41748 3.70605L11.9583 7.4998L8.41748 11.2936"
                stroke="#5F668C"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.04175 7.5H11.8592"
                stroke="#5F668C"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const CallingIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.8158 10.6928C12.8158 10.9028 12.7691 11.1187 12.67 11.3287C12.5708 11.5387 12.4425 11.737 12.2733 11.9237C11.9875 12.2387 11.6725 12.4662 11.3166 12.612C10.9666 12.7578 10.5875 12.8337 10.1791 12.8337C9.58413 12.8337 8.94829 12.6937 8.27746 12.4078C7.60662 12.122 6.93579 11.737 6.27079 11.2528C5.59996 10.7628 4.96413 10.2203 4.35746 9.61949C3.75663 9.01283 3.21413 8.37699 2.72996 7.71199C2.25163 7.04699 1.86663 6.38199 1.58663 5.72283C1.30663 5.05783 1.16663 4.42199 1.16663 3.81533C1.16663 3.41866 1.23663 3.03949 1.37663 2.68949C1.51663 2.33366 1.73829 2.00699 2.04746 1.71533C2.42079 1.34783 2.82913 1.16699 3.26079 1.16699C3.42413 1.16699 3.58746 1.20199 3.73329 1.27199C3.88496 1.34199 4.01913 1.44699 4.12413 1.59866L5.47746 3.50616C5.58246 3.65199 5.65829 3.78616 5.71079 3.91449C5.76329 4.03699 5.79246 4.15949 5.79246 4.27033C5.79246 4.41033 5.75163 4.55033 5.66996 4.68449C5.59413 4.81866 5.48329 4.95866 5.34329 5.09866L4.89996 5.55949C4.83579 5.62366 4.80663 5.69949 4.80663 5.79283C4.80663 5.83949 4.81246 5.88033 4.82413 5.92699C4.84163 5.97366 4.85913 6.00866 4.87079 6.04366C4.97579 6.23616 5.15663 6.48699 5.41329 6.79033C5.67579 7.09366 5.95579 7.40283 6.25913 7.71199C6.57412 8.02116 6.87746 8.30699 7.18662 8.56949C7.48996 8.82616 7.74079 9.00116 7.93912 9.10616C7.96829 9.11783 8.00329 9.13533 8.04413 9.15283C8.09079 9.17033 8.13746 9.17616 8.18996 9.17616C8.28912 9.17616 8.36496 9.14116 8.42912 9.07699L8.87246 8.63949C9.01829 8.49366 9.15829 8.38283 9.29246 8.31283C9.42663 8.23116 9.56079 8.19033 9.70662 8.19033C9.81746 8.19033 9.93412 8.21366 10.0625 8.26616C10.1908 8.31866 10.325 8.39449 10.4708 8.49366L12.4016 9.86449C12.5533 9.96949 12.6583 10.092 12.7225 10.2378C12.7808 10.3837 12.8158 10.5295 12.8158 10.6928Z"
                stroke={props.fill ? theme.palette.common[props.fill] : theme.palette.common.green3}
                strokeWidth="1.5"
                strokeMiterlimit="10"
            />
            <path
                d="M10.7917 5.25065C10.7917 4.90065 10.5175 4.36398 10.1092 3.92648C9.73583 3.52398 9.24 3.20898 8.75 3.20898"
                stroke={props.fill ? theme.palette.common[props.fill] : theme.palette.common.green3}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.8333 5.25033C12.8333 2.99283 11.0075 1.16699 8.75 1.16699"
                stroke={props.fill ? theme.palette.common[props.fill] : theme.palette.common.green3}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

CallingIcon.propTypes = {
    fill: PropTypes.string,
};

export const ActionPlusIcon = () => {
    return (
        <svg
            width="76"
            height="78"
            viewBox="0 0 76 78"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#filter0_d_4112_35159)">
                <path d="M33 14.5V32H16.5V38.5H32L41 32V14.5H33Z" fill="#2E63F0" />
                <path
                    d="M39.5 56L39.5 38.5L56 38.5L56 32L41 32L32 38.5L32 56L39.5 56Z"
                    fill="#6CBF93"
                />
            </g>
            <defs>
                <filter
                    id="filter0_d_4112_35159"
                    x="0.5"
                    y="0.5"
                    width="75.5"
                    height="77.5"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx="2" dy="4" />
                    <feGaussianBlur stdDeviation="9" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.4625 0 0 0 0 0.4625 0 0 0 0 0.4625 0 0 0 0.1 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_4112_35159"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_4112_35159"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
};

export const MoreIcon = () => {
    return (
        <svg
            width="3"
            height="13"
            viewBox="0 0 3 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="1.5" cy="1.5" r="1.5" fill="#C4C4C4" />
            <circle cx="1.5" cy="6.5" r="1.5" fill="#C4C4C4" />
            <circle cx="1.5" cy="11.5" r="1.5" fill="#C4C4C4" />
        </svg>
    );
};

export const CreditsIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width={props.width ? props.width : '16'}
            height={props.height ? props.height : '16'}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="8" cy="8" r="8" fill="#9766E8" />
            <path
                d="M8.61341 11.776C7.84541 11.776 7.16275 11.616 6.56541 11.296C5.96808 10.976 5.5023 10.5244 5.16808 9.94133C4.83386 9.35111 4.66675 8.66845 4.66675 7.89333C4.66675 7.11822 4.83386 6.43556 5.16808 5.84533C5.5023 5.25511 5.96808 4.8 6.56541 4.48C7.16275 4.16 7.84541 4 8.61341 4C9.63741 4 10.4943 4.25956 11.1841 4.77867V5.824C10.5654 5.27644 9.74053 5.00267 8.70941 5.00267C8.13341 5.00267 7.62141 5.12 7.17341 5.35467C6.73253 5.58933 6.38764 5.92711 6.13875 6.368C5.88986 6.80178 5.76541 7.31022 5.76541 7.89333C5.76541 8.47645 5.88986 8.98844 6.13875 9.42933C6.39475 9.87022 6.74319 10.208 7.18408 10.4427C7.63208 10.6773 8.14053 10.7947 8.70941 10.7947C9.23564 10.7947 9.70497 10.7271 10.1174 10.592C10.537 10.4498 10.9245 10.2258 11.2801 9.92V10.976C10.6401 11.5093 9.75119 11.776 8.61341 11.776Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'white'}
            />
        </svg>
    );
};

CreditsIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
};

export const ShowAllIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.3333 7.09999V3.31666C18.3333 2.14166 17.8 1.66666 16.475 1.66666H13.1083C11.7833 1.66666 11.25 2.14166 11.25 3.31666V7.09166C11.25 8.27499 11.7833 8.74166 13.1083 8.74166H16.475C17.8 8.74999 18.3333 8.27499 18.3333 7.09999Z"
                stroke={props.fill ? theme.palette.common[props.fill] : 'black'}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.3333 16.475V13.1083C18.3333 11.7833 17.8 11.25 16.475 11.25H13.1083C11.7833 11.25 11.25 11.7833 11.25 13.1083V16.475C11.25 17.8 11.7833 18.3333 13.1083 18.3333H16.475C17.8 18.3333 18.3333 17.8 18.3333 16.475Z"
                stroke={props.fill ? theme.palette.common[props.fill] : 'black'}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.75 7.09999V3.31666C8.75 2.14166 8.21667 1.66666 6.89167 1.66666H3.52501C2.20001 1.66666 1.66667 2.14166 1.66667 3.31666V7.09166C1.66667 8.27499 2.20001 8.74166 3.52501 8.74166H6.89167C8.21667 8.74999 8.75 8.27499 8.75 7.09999Z"
                stroke={props.fill ? theme.palette.common[props.fill] : 'black'}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.75 16.475V13.1083C8.75 11.7833 8.21667 11.25 6.89167 11.25H3.52501C2.20001 11.25 1.66667 11.7833 1.66667 13.1083V16.475C1.66667 17.8 2.20001 18.3333 3.52501 18.3333H6.89167C8.21667 18.3333 8.75 17.8 8.75 16.475Z"
                stroke={props.fill ? theme.palette.common[props.fill] : 'black'}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

ShowAllIcon.propTypes = {
    fill: PropTypes.string,
};

export const DropDownIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width="10"
            height="7"
            viewBox="0 0 10 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.744 6.17159C5.34666 6.61401 4.65334 6.61401 4.256 6.17159L0.436018 1.91818C-0.142143 1.27442 0.314742 0.25 1.18002 0.25L8.81999 0.250001C9.68526 0.250001 10.1421 1.27442 9.56398 1.91818L5.744 6.17159Z"
                fill={props.fill ? theme.palette.common[props.fill] : 'black'}
            />
        </svg>
    );
};

DropDownIcon.propTypes = {
    fill: PropTypes.string,
};

export const GalleryIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9 10C10.1046 10 11 9.10457 11 8C11 6.89543 10.1046 6 9 6C7.89543 6 7 6.89543 7 8C7 9.10457 7.89543 10 9 10Z"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.66998 18.95L7.59998 15.64C8.38998 15.11 9.52998 15.17 10.24 15.78L10.57 16.07C11.35 16.74 12.61 16.74 13.39 16.07L17.55 12.5C18.33 11.83 19.59 11.83 20.37 12.5L22 13.9"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

GalleryIcon.propTypes = {
    fill: PropTypes.string,
};

export const NotDeliveredIcon = () => {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="6" cy="6" r="5.25" stroke="#9A223E" strokeWidth="1.5" />
            <path d="M6 6.5L6 3" stroke="#9A223E" strokeWidth="1.5" />
            <path d="M6 9L6 7" stroke="#9A223E" strokeWidth="1.5" />
        </svg>
    );
};

export const CollapsedIcon = () => {
    return (
        <svg
            width="20"
            height="2"
            viewBox="0 0 20 2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M1 1H19" stroke="#454A67" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );
};

export const CopyIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.5 1.04199H9.11965C7.58819 1.04198 6.37516 1.04197 5.42582 1.16961C4.4488 1.30096 3.65801 1.57773 3.03437 2.20136C2.41073 2.825 2.13397 3.61579 2.00261 4.59281C1.87498 5.54215 1.87499 6.75518 1.875 8.28664V13.3337C1.875 14.8939 3.01838 16.187 4.51293 16.4209C4.6279 17.0576 4.84794 17.601 5.29029 18.0434C5.79189 18.545 6.42345 18.7607 7.17354 18.8616C7.89602 18.9587 8.81462 18.9587 9.95428 18.9587H12.5457C13.6854 18.9587 14.604 18.9587 15.3265 18.8616C16.0766 18.7607 16.7081 18.545 17.2097 18.0434C17.7113 17.5418 17.9271 16.9102 18.0279 16.1601C18.125 15.4376 18.125 14.519 18.125 13.3794V9.12127C18.125 7.98161 18.125 7.06301 18.0279 6.34053C17.9271 5.59044 17.7113 4.95888 17.2097 4.45728C16.7674 4.01493 16.2239 3.7949 15.5873 3.67992C15.3534 2.18537 14.0602 1.04199 12.5 1.04199ZM14.2744 3.55963C14.0221 2.82219 13.323 2.29199 12.5 2.29199H9.16667C7.57765 2.29199 6.44876 2.29332 5.59238 2.40846C4.75397 2.52118 4.27093 2.73257 3.91825 3.08525C3.56558 3.43792 3.35419 3.92096 3.24147 4.75937C3.12633 5.61575 3.125 6.74464 3.125 8.33366V13.3337C3.125 14.1566 3.6552 14.8558 4.39264 15.1081C4.37498 14.5998 4.37499 14.0251 4.375 13.3794V9.12126C4.37498 7.98161 4.37497 7.06301 4.4721 6.34053C4.57295 5.59044 4.7887 4.95888 5.29029 4.45728C5.79189 3.95569 6.42345 3.73994 7.17354 3.6391C7.89601 3.54196 8.81461 3.54198 9.95427 3.54199H12.5457C13.1914 3.54198 13.7661 3.54197 14.2744 3.55963ZM6.17418 5.34117C6.40481 5.11053 6.72862 4.96016 7.3401 4.87795C7.96956 4.79332 8.80382 4.79199 10 4.79199H12.5C13.6962 4.79199 14.5304 4.79332 15.1599 4.87795C15.7714 4.96016 16.0952 5.11053 16.3258 5.34117C16.5565 5.5718 16.7068 5.89561 16.789 6.50709C16.8737 7.13655 16.875 7.97081 16.875 9.16699V13.3337C16.875 14.5298 16.8737 15.3641 16.789 15.9936C16.7068 16.605 16.5565 16.9288 16.3258 17.1595C16.0952 17.3901 15.7714 17.5405 15.1599 17.6227C14.5304 17.7073 13.6962 17.7087 12.5 17.7087H10C8.80382 17.7087 7.96956 17.7073 7.3401 17.6227C6.72862 17.5405 6.40481 17.3901 6.17418 17.1595C5.94354 16.9288 5.79317 16.605 5.71096 15.9936C5.62633 15.3641 5.625 14.5298 5.625 13.3337V9.16699C5.625 7.97081 5.62633 7.13655 5.71096 6.50709C5.79317 5.89561 5.94354 5.5718 6.17418 5.34117Z"
                fill={props.fill ? theme.palette.common[props.fill] : theme.palette.common.white}
                stroke={props.fill ? theme.palette.common[props.fill] : theme.palette.common.white}
                strokeWidth="0.2"
            />
        </svg>
    );
};

CopyIcon.propTypes = {
    fill: PropTypes.string,
};

export const HospitalIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.33325 14.6665H14.6666"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.3333 1.3335H4.66667C2.66667 1.3335 2 2.52683 2 4.00016V14.6668H14V4.00016C14 2.52683 13.3333 1.3335 11.3333 1.3335Z"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.3734 10H6.62007C6.28007 10 5.99341 10.28 5.99341 10.6267V14.6667H9.99341V10.6267C10.0001 10.28 9.72007 10 9.3734 10Z"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 4V7.33333"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.33325 5.6665H9.66659"
                stroke={props.fill ? theme.palette.common[props.fill] : 'white'}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

HospitalIcon.propTypes = {
    fill: PropTypes.string,
};

export const LoadMoreIcon = () => {
    return (
        <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="15" cy="15" r="14.25" stroke="#848CB7" strokeWidth="1.5" />
            <path
                d="M15.2743 22.75V7.75"
                stroke="#848CB7"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.2987 16.7002L15.2747 22.7502L9.24969 16.7002"
                stroke="#848CB7"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const CircleArrowRight = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.75 8C14.75 9.79021 14.0388 11.5071 12.773 12.773C11.5071 14.0388 9.79021 14.75 8 14.75C6.20979 14.75 4.4929 14.0388 3.22703 12.773C1.96116 11.5071 1.25 9.79021 1.25 8C1.25 6.20979 1.96116 4.4929 3.22703 3.22703C4.4929 1.96116 6.20979 1.25 8 1.25C9.79021 1.25 11.5071 1.96116 12.773 3.22703C14.0388 4.4929 14.75 6.20979 14.75 8ZM16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8ZM7.47 5.53L9.19 7.25H4V8.75H9.19L7.47 10.47L8.53 11.53L11.53 8.53C11.6705 8.38937 11.7493 8.19875 11.7493 8C11.7493 7.80125 11.6705 7.61063 11.53 7.47L8.53 4.47L7.47 5.53Z"
                fill="white"
            />
        </svg>
    );
};

export const BulletIcon = () => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle opacity="0.1" cx="9" cy="9" r="9" fill="#217BF4" />
            <circle cx="9" cy="9" r="4" fill="#217BF4" />
        </svg>
    );
};

export const LineIcon = () => {
    return (
        <svg
            width="16"
            height="17"
            viewBox="0 0 30 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.221 11.959V16.8193C18.221 16.9424 18.1272 17.0381 18.0067 17.0381H17.2433C17.1696 17.0381 17.1027 16.9971 17.0692 16.9492L14.8862 13.9414V16.8262C14.8862 16.9492 14.7924 17.0449 14.6719 17.0449H13.9085C13.7879 17.0449 13.6942 16.9492 13.6942 16.8262V11.9658C13.6942 11.8428 13.7879 11.7471 13.9085 11.7471H14.6652C14.7321 11.7471 14.8058 11.7813 14.8393 11.8428L17.0223 14.8506V11.9658C17.0223 11.8428 17.1161 11.7471 17.2366 11.7471H18C18.1205 11.7402 18.221 11.8428 18.221 11.959ZM12.7299 11.7402H11.9665C11.846 11.7402 11.7522 11.836 11.7522 11.959V16.8193C11.7522 16.9424 11.846 17.0381 11.9665 17.0381H12.7299C12.8504 17.0381 12.9442 16.9424 12.9442 16.8193V11.959C12.9442 11.8428 12.8504 11.7402 12.7299 11.7402ZM10.8884 15.8145H8.8058V11.959C8.8058 11.836 8.71205 11.7402 8.59152 11.7402H7.82812C7.70759 11.7402 7.61384 11.836 7.61384 11.959V16.8193C7.61384 16.8809 7.63393 16.9287 7.67411 16.9697C7.71428 17.0039 7.76116 17.0313 7.82143 17.0313H10.8817C11.0022 17.0313 11.096 16.9356 11.096 16.8125V16.0332C11.096 15.917 11.0022 15.8145 10.8884 15.8145ZM22.2388 11.7402H19.1786C19.0647 11.7402 18.9643 11.836 18.9643 11.959V16.8193C18.9643 16.9356 19.058 17.0381 19.1786 17.0381H22.2388C22.3594 17.0381 22.4531 16.9424 22.4531 16.8193V16.0401C22.4531 15.917 22.3594 15.8213 22.2388 15.8213H20.1562V15.001H22.2388C22.3594 15.001 22.4531 14.9053 22.4531 14.7822V13.9961C22.4531 13.8731 22.3594 13.7774 22.2388 13.7774H20.1562V12.957H22.2388C22.3594 12.957 22.4531 12.8613 22.4531 12.7383V11.959C22.4464 11.8428 22.3527 11.7402 22.2388 11.7402ZM30 5.77247V25.2754C29.9933 28.3379 27.5357 30.8194 24.529 30.8125H5.42411C2.42411 30.8057 -0.00669788 28.2901 -1.45636e-06 25.2276V5.72462C0.00669497 2.66212 2.47098 0.180678 5.47098 0.187514H24.5759C27.5759 0.19435 30.0067 2.70314 30 5.77247ZM25.875 14.1533C25.875 9.1631 20.9732 5.10255 14.9531 5.10255C8.93303 5.10255 4.03125 9.1631 4.03125 14.1533C4.03125 18.624 7.91518 22.3701 13.1652 23.0811C14.4442 23.3613 14.2969 23.8399 14.0089 25.5967C13.9621 25.877 13.7879 26.6973 14.9531 26.1983C16.1183 25.6992 21.2411 22.418 23.5379 19.7246C25.1183 17.9473 25.875 16.1494 25.875 14.1533Z"
                fill="black"
            />
        </svg>
    );
};

export const FacebookIcon = () => {
    return (
        <svg
            width="6"
            height="13"
            viewBox="0 0 6 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.89782 12.6665V7.20164H5.67481L5.93895 5.06197H3.89782V3.69909C3.89782 3.08166 4.06363 2.65893 4.91774 2.65893H6V0.751297C5.47342 0.692748 4.94412 0.664478 4.41453 0.666617C2.84383 0.666617 1.76542 1.66144 1.76542 3.48773V5.05797H0V7.19764H1.76928V12.6665H3.89782Z"
                fill="black"
            />
        </svg>
    );
};

export const InstagramIcon = () => {
    return (
        <svg
            width="12"
            height="13"
            viewBox="0 0 12 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.99533 3.57983C5.17812 3.57983 4.39438 3.90447 3.81652 4.48233C3.23867 5.06018 2.91403 5.84392 2.91403 6.66113C2.91403 7.47834 3.23867 8.26208 3.81652 8.83994C4.39438 9.41779 5.17812 9.74243 5.99533 9.74243C6.81254 9.74243 7.59628 9.41779 8.17414 8.83994C8.75199 8.26208 9.07663 7.47834 9.07663 6.66113C9.07663 5.84392 8.75199 5.06018 8.17414 4.48233C7.59628 3.90447 6.81254 3.57983 5.99533 3.57983ZM5.99533 8.66224C5.46442 8.66224 4.95527 8.45134 4.57986 8.07593C4.20445 7.70053 3.99355 7.19137 3.99355 6.66047C3.99355 6.12956 4.20445 5.6204 4.57986 5.245C4.95527 4.86959 5.46442 4.65869 5.99533 4.65869C6.52623 4.65869 7.03539 4.86959 7.4108 5.245C7.78621 5.6204 7.99711 6.12956 7.99711 6.66047C7.99711 7.19137 7.78621 7.70053 7.4108 8.07593C7.03539 8.45134 6.52623 8.66224 5.99533 8.66224Z"
                fill="black"
            />
            <path
                d="M9.19866 4.18499C9.5954 4.18499 9.91701 3.86337 9.91701 3.46664C9.91701 3.06991 9.5954 2.74829 9.19866 2.74829C8.80193 2.74829 8.48032 3.06991 8.48032 3.46664C8.48032 3.86337 8.80193 4.18499 9.19866 4.18499Z"
                fill="black"
            />
            <path
                d="M11.6821 2.73625C11.5279 2.33788 11.2921 1.97611 10.99 1.6741C10.6879 1.37208 10.326 1.13648 9.92759 0.982364C9.46135 0.807346 8.9688 0.712711 8.4709 0.702488C7.82919 0.6745 7.62594 0.666504 5.99867 0.666504C4.37139 0.666504 4.16282 0.666504 3.52643 0.702488C3.02891 0.712188 2.53671 0.806843 2.07108 0.982364C1.67255 1.1363 1.31059 1.37184 1.00844 1.67388C0.706289 1.97591 0.47061 2.33778 0.316526 2.73625C0.141474 3.20245 0.0470554 3.69505 0.0373167 4.19294C0.00866281 4.83398 0 5.03723 0 6.66517C0 8.29245 -4.96485e-09 8.49969 0.0373167 9.13741C0.0473123 9.63585 0.14127 10.1276 0.316526 10.5948C0.471042 10.9931 0.70695 11.3548 1.00918 11.6568C1.3114 11.9588 1.6733 12.1944 2.07175 12.3486C2.5365 12.5307 3.0289 12.6321 3.52777 12.6485C4.16948 12.6765 4.37272 12.6852 6 12.6852C7.62728 12.6852 7.83585 12.6852 8.47223 12.6485C8.97008 12.6384 9.46262 12.544 9.92892 12.3693C10.3272 12.2148 10.689 11.979 10.9911 11.6769C11.2932 11.3748 11.529 11.0131 11.6835 10.6147C11.8587 10.1483 11.9527 9.65651 11.9627 9.15806C11.9913 8.51701 12 8.31377 12 6.68583C12 5.05789 12 4.85131 11.9627 4.21359C11.9549 3.70867 11.86 3.20887 11.6821 2.73625ZM10.8705 9.08809C10.8662 9.47213 10.7961 9.85258 10.6633 10.2129C10.5632 10.4721 10.41 10.7074 10.2135 10.9037C10.017 11.1001 9.78162 11.2532 9.52243 11.3531C9.16608 11.4853 8.78967 11.5554 8.4096 11.5603C7.77654 11.5896 7.59796 11.597 5.97468 11.597C4.35007 11.597 4.18414 11.597 3.53909 11.5603C3.15921 11.5557 2.78298 11.4856 2.42692 11.3531C2.16683 11.2538 1.93048 11.101 1.73316 10.9046C1.53584 10.7082 1.38194 10.4726 1.28143 10.2129C1.15045 9.85645 1.08039 9.48048 1.07419 9.10075C1.04554 8.4677 1.03887 8.28912 1.03887 6.66584C1.03887 5.04189 1.03887 4.87597 1.07419 4.23025C1.0785 3.84644 1.14859 3.46621 1.28143 3.10609C1.48467 2.58032 1.90116 2.1665 2.42692 1.96526C2.78316 1.83341 3.15928 1.76333 3.53909 1.75802C4.17281 1.72936 4.35073 1.72137 5.97468 1.72137C7.59862 1.72137 7.76522 1.72137 8.4096 1.75802C8.7897 1.76259 9.16617 1.8327 9.52243 1.96526C9.7816 2.0654 10.017 2.21862 10.2134 2.41508C10.4099 2.61154 10.5631 2.84692 10.6633 3.10609C10.7942 3.46256 10.8643 3.83853 10.8705 4.21826C10.8992 4.85198 10.9065 5.0299 10.9065 6.65384C10.9065 8.27712 10.9065 8.45171 10.8778 9.08876H10.8705V9.08809Z"
                fill="black"
            />
        </svg>
    );
};

export const YoutubeIcon = () => {
    return (
        <svg
            width="13"
            height="10"
            viewBox="0 0 13 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.7355 2.08151C12.6616 1.81007 12.517 1.56253 12.3162 1.36352C12.1154 1.16451 11.8654 1.02097 11.5911 0.947196C10.5739 0.671005 6.5045 0.666509 6.5045 0.666509C6.5045 0.666509 2.43578 0.662013 1.41795 0.926C1.14379 1.00317 0.894302 1.14874 0.693428 1.34872C0.492554 1.54871 0.347041 1.7964 0.270859 2.06802C0.00259923 3.07387 9.51671e-07 5.16008 9.51671e-07 5.16008C9.51671e-07 5.16008 -0.0025972 7.25657 0.263714 8.25214C0.413109 8.8026 0.851549 9.23744 1.40885 9.38581C2.43643 9.662 6.49476 9.6665 6.49476 9.6665C6.49476 9.6665 10.5641 9.67099 11.5813 9.40765C11.8557 9.334 12.106 9.1908 12.3073 8.99219C12.5086 8.79359 12.6539 8.54647 12.729 8.27527C12.998 7.27006 12.9999 5.18449 12.9999 5.18449C12.9999 5.18449 13.0129 3.08736 12.7355 2.08151ZM5.20282 7.09278L5.20607 3.23894L8.58823 5.16907L5.20282 7.09278Z"
                fill="black"
            />
        </svg>
    );
};

export const CallIcon = () => {
    return (
        <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M23.8009 19.8576C23.8009 20.2476 23.7142 20.6484 23.5301 21.0384C23.3459 21.4284 23.1076 21.7967 22.7934 22.1434C22.2626 22.7284 21.6776 23.1509 21.0167 23.4217C20.3667 23.6926 19.6626 23.8334 18.9042 23.8334C17.7992 23.8334 16.6184 23.5734 15.3726 23.0426C14.1267 22.5117 12.8809 21.7967 11.6459 20.8976C10.4001 19.9876 9.21925 18.9801 8.09258 17.8642C6.97675 16.7376 5.96925 15.5567 5.07008 14.3217C4.18175 13.0867 3.46675 11.8517 2.94675 10.6276C2.42675 9.39258 2.16675 8.21175 2.16675 7.08508C2.16675 6.34841 2.29675 5.64425 2.55675 4.99425C2.81675 4.33341 3.22841 3.72675 3.80258 3.18508C4.49591 2.50258 5.25425 2.16675 6.05592 2.16675C6.35925 2.16675 6.66258 2.23175 6.93341 2.36175C7.21508 2.49175 7.46425 2.68675 7.65925 2.96841L10.1726 6.51091C10.3676 6.78175 10.5084 7.03091 10.6059 7.26925C10.7034 7.49675 10.7576 7.72425 10.7576 7.93008C10.7576 8.19008 10.6817 8.45008 10.5301 8.69925C10.3892 8.94841 10.1834 9.20841 9.92341 9.46841L9.10008 10.3242C8.98091 10.4434 8.92675 10.5842 8.92675 10.7576C8.92675 10.8442 8.93758 10.9201 8.95925 11.0067C8.99175 11.0934 9.02425 11.1584 9.04592 11.2234C9.24092 11.5809 9.57675 12.0467 10.0534 12.6101C10.5409 13.1734 11.0609 13.7476 11.6242 14.3217C12.2092 14.8959 12.7726 15.4267 13.3467 15.9142C13.9101 16.3909 14.3759 16.7159 14.7442 16.9109C14.7984 16.9326 14.8634 16.9651 14.9392 16.9976C15.0259 17.0301 15.1126 17.0409 15.2101 17.0409C15.3942 17.0409 15.5351 16.9759 15.6542 16.8567L16.4776 16.0442C16.7484 15.7734 17.0084 15.5676 17.2576 15.4376C17.5067 15.2859 17.7559 15.2101 18.0267 15.2101C18.2326 15.2101 18.4492 15.2534 18.6876 15.3509C18.9259 15.4484 19.1751 15.5892 19.4459 15.7734L23.0317 18.3192C23.3134 18.5142 23.5084 18.7417 23.6276 19.0126C23.7359 19.2834 23.8009 19.5542 23.8009 19.8576Z"
                stroke="#DDE1F0"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
        </svg>
    );
};

export const SMSIcon = () => {
    return (
        <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.4167 22.2084H7.58341C4.33341 22.2084 2.16675 20.5834 2.16675 16.7917V9.20841C2.16675 5.41675 4.33341 3.79175 7.58341 3.79175H18.4167C21.6667 3.79175 23.8334 5.41675 23.8334 9.20841V16.7917C23.8334 20.5834 21.6667 22.2084 18.4167 22.2084Z"
                stroke="#DDE1F0"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.4166 9.75L15.0257 12.4583C13.9099 13.3467 12.0791 13.3467 10.9632 12.4583L7.58325 9.75"
                stroke="#DDE1F0"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const ListIcon = ({ $width, $height, $color }) => {
    return (
        <svg
            width={$width ? $width : '24'}
            height={$height ? $height : '24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 6C7 5.44772 7.44772 5 8 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H8C7.44772 7 7 6.55228 7 6Z"
                fill={$color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 12C7 11.4477 7.44772 11 8 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H8C7.44772 13 7 12.5523 7 12Z"
                fill={$color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 18C7 17.4477 7.44772 17 8 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H8C7.44772 19 7 18.5523 7 18Z"
                fill={$color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 6C2 5.44772 2.44772 5 3 5H3.01C3.56228 5 4.01 5.44772 4.01 6C4.01 6.55228 3.56228 7 3.01 7H3C2.44772 7 2 6.55228 2 6Z"
                fill={$color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 12C2 11.4477 2.44772 11 3 11H3.01C3.56228 11 4.01 11.4477 4.01 12C4.01 12.5523 3.56228 13 3.01 13H3C2.44772 13 2 12.5523 2 12Z"
                fill={$color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 18C2 17.4477 2.44772 17 3 17H3.01C3.56228 17 4.01 17.4477 4.01 18C4.01 18.5523 3.56228 19 3.01 19H3C2.44772 19 2 18.5523 2 18Z"
                fill={$color}
            />
        </svg>
    );
};

export const CheckCircleIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="12"
                cy="12"
                r="11.5"
                fill={
                    props.fill ? theme.palette.common[props.fill] : theme.palette.common.primaryBlue
                }
                stroke={
                    props.fill ? theme.palette.common[props.fill] : theme.palette.common.primaryBlue
                }
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.569 6.29491C18.0777 6.74412 18.1459 7.54451 17.7212 8.08263L11.0429 16.5441C10.8228 16.8231 10.5002 16.9888 10.1568 16.9995C9.8134 17.0101 9.48217 16.8645 9.247 16.5997L6.32527 13.3091C5.87158 12.7981 5.89541 11.9949 6.37851 11.515C6.86161 11.0351 7.62104 11.0603 8.07473 11.5713L10.0689 13.8172L15.8788 6.45589C16.3035 5.91777 17.0602 5.84569 17.569 6.29491Z"
                fill="white"
            />
        </svg>
    );
};

export const UnCheckCircleIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle opacity="0.4" cx="12" cy="12" r="11.5" fill="#CBCEDD" stroke="#CBCEDD" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.569 6.29491C18.0777 6.74412 18.1459 7.54451 17.7212 8.08263L11.0429 16.5441C10.8228 16.8231 10.5002 16.9888 10.1568 16.9995C9.8134 17.0101 9.48217 16.8645 9.247 16.5997L6.32527 13.3091C5.87158 12.7981 5.89541 11.9949 6.37851 11.515C6.86161 11.0351 7.62104 11.0603 8.07473 11.5713L10.0689 13.8172L15.8788 6.45589C16.3035 5.91777 17.0602 5.84569 17.569 6.29491Z"
                fill="white"
            />
        </svg>
    );
};

export const CrossCircleIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="12" cy="12" r="11.5" fill="#EA4335" stroke="#EA4335" />
            <path
                d="M7.24586 6.65077C7.11246 6.70608 6.99128 6.78715 6.88924 6.88934L6.96 6.96L6.88934 6.88924C6.78715 6.99128 6.70608 7.11246 6.65077 7.24586C6.59546 7.37926 6.56699 7.52225 6.56699 7.66666C6.56699 7.81108 6.59546 7.95407 6.65077 8.08747C6.70608 8.22085 6.78713 8.34202 6.8893 8.44405C6.88931 8.44407 6.88932 8.44408 6.88934 8.44409L10.4439 12L6.88929 15.556C6.88928 15.556 6.88928 15.556 6.88927 15.556C6.68311 15.7621 6.56729 16.0418 6.56729 16.3333C6.56729 16.6249 6.68311 16.9045 6.88929 17.1107C7.09546 17.3169 7.37509 17.4327 7.66666 17.4327C7.95823 17.4327 8.23786 17.3169 8.44403 17.1107C8.44403 17.1107 8.44404 17.1107 8.44404 17.1107L12 13.5561L15.556 17.1107C15.7621 17.3169 16.0418 17.4327 16.3333 17.4327C16.6249 17.4327 16.9045 17.3169 17.1107 17.1107C17.3169 16.9045 17.4327 16.6249 17.4327 16.3333C17.4327 16.0418 17.3169 15.7621 17.1107 15.556L13.5561 12L17.1107 8.44404C17.1107 8.44404 17.1107 8.44403 17.1107 8.44403C17.2128 8.34194 17.2938 8.22076 17.349 8.08738C17.4043 7.954 17.4327 7.81104 17.4327 7.66666C17.4327 7.52229 17.4043 7.37933 17.349 7.24595C17.2938 7.11257 17.2128 6.99137 17.1107 6.88929C17.0086 6.7872 16.8874 6.70622 16.754 6.65097C16.6207 6.59572 16.4777 6.56729 16.3333 6.56729C16.189 6.56729 16.046 6.59572 15.9126 6.65097C15.7792 6.70622 15.658 6.78719 15.556 6.88927C15.556 6.88928 15.556 6.88928 15.556 6.88929L12 10.4439L8.44409 6.88934C8.44408 6.88932 8.44407 6.88931 8.44405 6.8893C8.34202 6.78713 8.22085 6.70608 8.08747 6.65077C7.95407 6.59546 7.81108 6.56699 7.66666 6.56699C7.52225 6.56699 7.37926 6.59546 7.24586 6.65077Z"
                fill="white"
                stroke="white"
                strokeWidth="0.2"
            />
        </svg>
    );
};

export const SyncIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.5 9.99998C2.4998 8.44894 2.98049 6.93599 3.87586 5.66948C4.77123 4.40298 6.03725 3.44522 7.49955 2.92812C8.96185 2.41101 10.5485 2.35999 12.041 2.78208C13.5335 3.20417 14.8584 4.07861 15.8333 5.28498"
                stroke="#789EFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.2503 2.5V5.83333H12.917M17.5003 10C17.5004 11.551 17.0195 13.0638 16.1241 14.3302C15.2287 15.5965 13.9626 16.5542 12.5004 17.0712C11.0381 17.5882 9.45154 17.6391 7.95911 17.217C6.46669 16.7949 5.14184 15.9205 4.16699 14.7142"
                stroke="#789EFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.75 17.5003V14.167H7.08333"
                stroke="#789EFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const CheckIcon = (props) => {
    const theme = useTheme();

    return (
        <svg
            width={props.width || '18'}
            height={props.height || '20'}
            viewBox="0 0 18 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_567_7775)">
                <path
                    d="M17.0464 4.11719C17.5322 4.60547 17.5322 5.39844 17.0464 5.88672L7.09683 15.8867C6.61101 16.375 5.82204 16.375 5.33622 15.8867L0.361435 10.8867C-0.124385 10.3984 -0.124385 9.60547 0.361435 9.11719C0.847254 8.62891 1.63622 8.62891 2.12204 9.11719L6.21847 13.2305L15.2897 4.11719C15.7755 3.62891 16.5645 3.62891 17.0503 4.11719H17.0464Z"
                    fill={
                        props.fill ? theme.palette.common[props.fill] : theme.palette.common.white
                    }
                />
            </g>
            <defs>
                <clipPath id="clip0_567_7775">
                    <rect
                        width="17.4118"
                        height="20"
                        fill={
                            props.fill
                                ? theme.palette.common[props.fill]
                                : theme.palette.common.white
                        }
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const PlusIcon = () => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.99984 2.33301C7.322 2.33301 7.58317 2.59418 7.58317 2.91634V11.083C7.58317 11.4052 7.322 11.6663 6.99984 11.6663C6.67767 11.6663 6.4165 11.4052 6.4165 11.083V2.91634C6.4165 2.59418 6.67767 2.33301 6.99984 2.33301Z"
                fill="#789EFF"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.3335 7.00033C2.3335 6.67816 2.59466 6.41699 2.91683 6.41699H11.0835C11.4057 6.41699 11.6668 6.67816 11.6668 7.00033C11.6668 7.32249 11.4057 7.58366 11.0835 7.58366H2.91683C2.59466 7.58366 2.3335 7.32249 2.3335 7.00033Z"
                fill="#789EFF"
            />
        </svg>
    );
};

export const InfoCirCleIconPermission = (props) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_12997_178)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.0003 17.5C14.1425 17.5 17.5003 14.1421 17.5003 10C17.5003 5.85787 14.1425 2.5 10.0003 2.5C5.85819 2.5 2.50032 5.85787 2.50032 10C2.50032 14.1421 5.85819 17.5 10.0003 17.5ZM19.167 10C19.167 15.0626 15.0629 19.1667 10.0003 19.1667C4.93771 19.1667 0.833658 15.0626 0.833658 10C0.833658 4.93739 4.93771 0.833338 10.0003 0.833338C15.0629 0.833338 19.167 4.93739 19.167 10Z"
                    fill="#C03744"
                />
                <path
                    d="M17.5003 10C17.5003 14.1421 14.1425 17.5 10.0003 17.5C5.85819 17.5 2.50032 14.1421 2.50032 10C2.50032 5.85787 5.85819 2.5 10.0003 2.5C14.1425 2.5 17.5003 5.85787 17.5003 10Z"
                    fill="#C03744"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.99967 10.8333C9.53944 10.8333 9.16634 10.4602 9.16634 9.99999V6.66666C9.16634 6.20642 9.53944 5.83333 9.99967 5.83333C10.4599 5.83333 10.833 6.20642 10.833 6.66666V9.99999C10.833 10.4602 10.4599 10.8333 9.99967 10.8333Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.833 13.3333C10.833 13.7936 10.4599 14.1667 9.99967 14.1667H9.99134C9.5311 14.1667 9.15801 13.7936 9.15801 13.3333C9.15801 12.8731 9.5311 12.5 9.99134 12.5H9.99967C10.4599 12.5 10.833 12.8731 10.833 13.3333Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_12997_178">
                    <rect width="20" height="20" fill="white" transform="matrix(-1 0 0 -1 20 20)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const ClosePermission = (props) => {
    return (
        <svg
            width="11"
            height="11"
            viewBox="0 0 11 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.73758 2.11557C10.1369 1.71624 10.1369 1.06879 9.73758 0.669461C9.33824 0.270128 8.6908 0.270128 8.29146 0.669461L5.15822 3.80271L2.02496 0.669449C1.62562 0.270116 0.978175 0.270116 0.578842 0.669449C0.179509 1.06878 0.179509 1.71623 0.578842 2.11556L3.7121 5.24882L0.57886 8.38206C0.179527 8.7814 0.179527 9.42884 0.57886 9.82818C0.978193 10.2275 1.62564 10.2275 2.02497 9.82818L5.15822 6.69493L8.29145 9.82817C8.69078 10.2275 9.33823 10.2275 9.73756 9.82817C10.1369 9.42883 10.1369 8.78139 9.73756 8.38205L6.60433 5.24882L9.73758 2.11557Z"
                fill="#B7B9B8"
            />
        </svg>
    );
};
